<template>
  <div class="animated fadeIn">
    <!-- Added code     -->
    <div
      class="col-md-12"
      style="float: left; margin-bottom: 15px; margin-top: 10px"
    >
      <div class="accordion" role="tablist">
        <div style="text-align: left">
          <label><b>Sub Category</b></label>
          <!-- {{result_data}} -->

          <!--- SubCat v-for Loop -->
          <div
            class="container-fluid"
            id="subcategory_section"
            v-if="sub_cat_id_arr != ''"
          >
            <b-card
              no-body
              class="mb-1"
              v-for="(subcatlist, index) in sub_cat_id_arr"
              :key="subcatlist.sub_catid"
            >
              <!--  -->
              <b-card-header
                header-tag="header"
                class="p-1"
                role="tab"
                v-bind:id="'collapse' + index"
                @click="getPoTypeList(subcatlist.sub_catid)"
              >
                <b-button
                  block
                  v-b-toggle="'accordion-' + subcatlist.sub_catid"
                  variant="info"
                  style="background: #f8f8f8; text-align: left"
                  >{{ subcatlist.sub_cattitle }}</b-button
                >
              </b-card-header>

              <b-collapse
                class="'accordion-' + subcatlist.sub_catid"
                v-bind:id="'accordion-' + subcatlist.sub_catid"
                accordion="my-accordion"
                role="tabpanel"
              >
                <!-- PO Type Loop -->
                <div
                  class="container-fluid"
                  id="po_section"
                  v-if="
                    po_typearr != '' &&
                    selected_subcat_tab == subcatlist.sub_catid
                  "
                >
                  <b-card-body style="background: #fff; padding: 8px">
                    <b-card-text style="text-align: left"
                      ><b>PO Type</b></b-card-text
                    >
                    <b-card-text>
                      <div>
                        <!-- fill  -->
                        <b-tabs content-class="mt-3">
                          <b-tab
                            v-for="potypelist in po_typearr"
                            :key="potypelist.potype_title"
                            v-bind:title="potypelist.potype_title"
                            @click="
                              setpoid(potypelist.po_id, subcatlist.sub_catid)
                            "
                          >
                            <!-- Utility Type Loop -->
                            <div
                              class="container-fluid"
                              id="utility_section"
                              v-if="
                                utility_type_arr != '' &&
                                selected_poid_tab == potypelist.po_id
                              "
                            >
                              <b-card-text style="text-align: left"
                                ><b>Utility Type</b></b-card-text
                              >
                              <div class="accordion" role="tablist">
                                <b-card
                                  no-body
                                  class="mb-1"
                                  v-for="utilitylist in utility_type_arr"
                                  :key="utilitylist.utilitytype_title"
                                  style="background: #f8f9f9 !important"
                                >
                                  <b-card-header
                                    header-tag="header"
                                    class="p-2"
                                    role="tab"
                                    :key="utilitylist.utility_id"
                                  >
                                    <b-button
                                      block
                                      v-b-toggle="
                                        'accordionpo-' + utilitylist.utility_id
                                      "
                                      variant="info"
                                      style="
                                        background: #c0c0c0;
                                        text-align: left;
                                      "
                                      @click="
                                        setutilityid(
                                          utilitylist.utility_id,
                                          subcatlist.sub_catid,
                                          selected_po_id
                                        )
                                      "
                                      >{{
                                        utilitylist.utilitytype_title
                                      }}</b-button
                                    >
                                  </b-card-header>
                                  <!-- visible -->
                                  <b-collapse
                                    v-bind:id="
                                      'accordionpo-' + utilitylist.utility_id
                                    "
                                    accordion="my-accordion1"
                                    :role="subcatlist.sub_catid"
                                  >
                                    <b-card-body
                                      style="margin: 30px"
                                      id="cardbody"
                                    >
                                      <!-- <b-card-text > -->
                                      <!-- - Design Section Start -->
                                      <div
                                        v-if="
                                          selected_utility_tab ==
                                          utilitylist.utility_id
                                        "
                                      >
                                        <div
                                          v-for="(
                                            style_collections, index
                                          ) in count_data"
                                          class="col-md-4"
                                          style="
                                            float: left;
                                            margin-bottom: 20px;
                                            margin-top: 10px;
                                          "
                                        >
                                          <!-- <div v-for="(count_details, index) in count_data">                                                                                                                            -->
                                          <b-card-group deck>
                                            <b-card
                                              class="design_card"
                                              header-tag="header"
                                              v-bind:id="
                                                style_collections.design_id
                                              "
                                            >
                                              <template v-slot:header>
                                                <div
                                                  class="col-md-12"
                                                  style="padding-left: 0px"
                                                >
                                                  <h6 class="mb-0">
                                                    <a
                                                      class=""
                                                      style="text-align: center"
                                                      >{{
                                                        style_collections.design_title
                                                      }}</a
                                                    >

                                                    <span
                                                      v-if="
                                                        user_type != 'Buyer'
                                                      "
                                                      ><i
                                                        @click="
                                                          openeditstyle(
                                                            style_collections.design_title,
                                                            style_collections.design_hit,
                                                            style_collections.design_id,
                                                            style_collections.buyer_id
                                                          )
                                                        "
                                                        title="Edit Style"
                                                        class="fa fa-pencil icons font-1xl d-block pull-right pointer"
                                                      ></i
                                                    ></span>
                                                  </h6>
                                                </div>
                                              </template>

                                              <!-- Added Code Start -->
                                              <b-card-text
                                                style="
                                                  max-height: 250px;
                                                  overflow-y: scroll;
                                                "
                                              >
                                                <!-- Code For Display Style List -->
                                                <!-- Code By Prasad -->
                                                <div
                                                  col-md="12"
                                                  v-bind:id="
                                                    'design_' +
                                                    style_collections.design_id
                                                  "
                                                >
                                                  <button
                                                    type="button"
                                                    class="btn btn-primary"
                                                    style="
                                                      margin-left: 35%;
                                                      margin-top: 20px;
                                                    "
                                                    @click="
                                                      showstyledetails(
                                                        style_collections.design_id
                                                      )
                                                    "
                                                    v-if="
                                                      style_collections.style_count >
                                                      0
                                                    "
                                                  >
                                                    {{
                                                      style_collections.style_count
                                                    }}
                                                    Styles
                                                  </button>

                                                  <button
                                                    type="button"
                                                    class="btn btn-primary"
                                                    style="
                                                      margin-left: 35%;
                                                      margin-top: 20px;
                                                    "
                                                    v-if="
                                                      style_collections.style_count ==
                                                      0
                                                    "
                                                  >
                                                    {{
                                                      style_collections.style_count
                                                    }}
                                                    Styles
                                                  </button>
                                                  <!-- <div class="dynamicHtmlRender" v-html="dynamicHtml"></div> -->
                                                </div>
                                                <!-- Code By Prasad -->
                                                <!-- Code for Display Style List -->
                                              </b-card-text>
                                              <template
                                                v-slot:footer
                                                style="
                                                  border-radius: 0px !important;
                                                "
                                              >
                                                <!-- <span class="mb-0">
                                                  {{
                                                    style_collections.style_count
                                                  }}
                                                  Colors(s)

                                                 </span> -->
                                                  <b-col
                                                    class="col-md-1"
                                                    style="float: right"
                                                  >
                                                    <!-- style_collections.design_id,style_collections.design_title,style_collection.buyer_id.index -->

                                                    <span
                                                      @click="
                                                        addStyleDetails(
                                                          style_collections.design_id,
                                                          style_collections.design_title,
                                                          style_collections.sub_catid
                                                        )
                                                      "
                                                    >
                                                      <i @click="fabrictypefunation();"
                                                        title="Add New Style"
                                                        class="pointer fa fa-plus icons font-1xl d-block"
                                                      ></i>
                                                    </span>
                                                  </b-col>
                                               
                                              </template>
                                            </b-card>
                                          </b-card-group>
                                          <!-- </div> -->
                                        </div>
                                      </div>
                                      <!-- - Design Section Start -->

                                      <!-- Added New Code Ends -->
                                      <div
                                        v-if="resuld_data_msg == 'Unsuccessful'"
                                        style="
                                          top: 50%;
                                          position: absolute;
                                          bottom: 50;
                                          right: 50%;
                                          left: 45%;
                                        "
                                        id="btn_centered"
                                      >
                                        <b-col
                                          sm="4"
                                          md="2"
                                          xl
                                          class="mb-3 mb-xl-0"
                                          v-if="user_type != 'Buyer'"
                                        >
                                          <b-button
                                            title="Add New Design"
                                            @click="addNewDesign=true"
                                            variant="danger"
                                            aria-pressed="true"
                                            class="fa fa-plus-circle fa-5x pointer"
                                            style="width: 150px !important"
                                            >&nbsp; Create New Style</b-button
                                          >
                                        </b-col>
                                      </div>

                                      <!--- Card End -->

                                      <!-- </b-card-text> -->
                                      <!-- <div id="mybutton" v-if="style_list!=''" >
        
                                 <b-col  sm="4" md="2" xl class="mb-3 mb-xl-0" >
                                  <b-button title="Add New Design" @click="openaddNewDesign" variant="danger" aria-pressed="true" class="fa fa-plus-circle fa-5x pointer" >&nbsp; Create New Style</b-button>

                                </b-col>

                                </div> -->
                                    </b-card-body>
                                    <div
                                      style="
                                        /*top: 100%;*/
                                        position: absolute;
                                        text-align: right;
                                        float: left;
                                        width: 100%;
                                      "
                                      v-if="count_data != ''"
                                    >
                                      <b-col
                                        sm="4"
                                        md="2"
                                        xl
                                        class="mb-3 mb-xl-0"
                                        v-if="user_type != 'Buyer'"
                                      >
                                        <b-button
                                          title="Add New Design"
                                          @click="addNewDesignmodel()"
                                          variant="danger"
                                          aria-pressed="true"
                                          class="fa fa-plus-circle fa-5x pointer"
                                          style="width: 150px !important"
                                          >&nbsp; Create New Style</b-button
                                        >
                                      </b-col>
                                    </div>
                                  </b-collapse>
                                </b-card>
                              </div>
                            </div>
                            <!-- Utility Type Loop End -->
                          </b-tab>
                        </b-tabs>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </div>
                <!-- PO Type Loop End-->
              </b-collapse>
            </b-card>
          </div>
          <!--- SubCat v-for Loop End -->
        </div>
      </div>
      <!-- Added Code Ends -->

      <!-- Added New Code -->
      <!-- Add New Design Model -->
      <!-- <div v-if="addNewDesign== true" > -->
      <b-modal 
        title="Create New Style"
        v-model="addNewDesign"
        @ok="addNewDesign = false">
        <b-row>
          <!-- style="border: 1px solid; padding: 55px;box-shadow: 5px 8px #888888;" -->
          <b-col sm="12" class="col-md-12">
            <!-- <b-form name="createdesignform" @submit.prevent="createdesignForm('createdesignform')" > -->
            <b-form @submit.prevent="createdesignForm(selcted_design_title)">
              <b-col sm="12">
                <div class="col-md-12">
                  <label for="name">Style Title</label>
                  <!-- v-validate="'required|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.design_title') }" -->
                  <b-form-input
                    type="text"
                    id="selcted_design_title"
                    name="selcted_design_title"
                    placeholder="Please Enter Design Title."
                    required
                  ></b-form-input>
                </div>
                <br />
                <div class="col-md-12">
                  <label for="selcted_design_hit">Design Hit</label>
                  <b-form-input
                    type="text"
                    id="selcted_design_hit"
                    name="selcted_design_hit"
                    placeholder="Please Input Design Hit..."
                    required
                  ></b-form-input>
                </div>
                <br />

                <div class="col-md-12" v-if="user_type != 'Buyer'">
                  <label for="name">Select Buyer</label>

                  <div id="myapp">
                    <input
                      type="checkbox"
                      @click="checkAll()"
                      v-model="isCheckAll"
                    />
                    Check All

                    <table class="table col-md-12" id="myTable">
                      <thead>
                        <tr>
                          <td scope="col">Buyer Name</td>
                          <td scope="col">Designation</td>
                        </tr>
                      </thead>
                      <tbody v-if="buyer_response == 'Successful'">
                        <tr v-for="opt in agentmaster">
                          <td>
                            <input
                              type="checkbox"
                              v-bind:value="opt.buyer_id"
                              v-model="selectedbuyers"
                              @change="updateCheckall()"
                            />&nbsp;{{ opt.buyer_name }}
                          </td>
                          <td>{{ opt.designation }}</td>
                        </tr>
                      </tbody>
                      <tbody v-if="buyer_response == 'Unsuccessful'">
                        <tr>
                          <td colspan="3" style="text-align: center">
                            No Records Found
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('buyer_id')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.buyer_id')" id="statustxt" class="help text-danger">{{ errors.first('form-1.buyer_id') }}
                        </code>
                    </b-input-group> -->
                  </div>
                </div>
                <br />
              </b-col>
              <div slot="footer" style="margin-top: 20px">
                <b-button
                  type="submit"
                  variant="primary"
                  class="px-4 pull-right"
                  >Create New Style</b-button
                >
              </div>
            </b-form>
          </b-col>
        </b-row>
      </b-modal>
      <!-- </div> -->
      <!-- Add New Design Model Ends-->

      <!-- Code For style Add Model -->
      <!-- Edit Style Modal -->
      <!-- <div v-if="editstyleModal == true"> -->
      <b-modal
        title="Edit Style"
        v-model="editstyleModal"
        @ok="editstyleModal = true"
      >
        <b-form name="designform" @submit.prevent="AddDesign('designform')">
          <!-- <div  class='row' > -->

          <!-- <b-col sm="12" class='col-md-12'> -->

          <!-- <b-form name="createdesignform" @submit.prevent="createdesignForm('createdesignform')" > -->
          <b-row>
            <!-- style="border: 1px solid; padding: 45px;box-shadow: 5px 8px #888888;" -->
            <b-col sm="12" class="col-md-12">
              <b-form
                @submit.prevent="validateForm2('form-1')"
                data-vv-scope="form-1"
              >
                <b-col sm="12">
                  <div class="col-md-12">
                    <label for="name">Style Title</label>
                    <!-- v-validate="'required|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.design_title') }" -->
                    <b-form-input
                      type="text"
                      id="edit_design_title"
                      name="design_title"
                      placeholder="Please Enter Design Title."
                      required
                    ></b-form-input>
                    <!-- <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('design_title')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.design_title')" class="help text-danger">{{ errors.first('form-1.design_title') }}</span>
                      </b-input-group> -->
                  </div>
                  <br />
                  <div class="col-md-12">
                    <label for="name">Design Hit</label>
                    <b-form-input
                      type="text"
                      id="edit_design_hit"
                      name="design_hit"
                      placeholder="Please Input Design Hit...."
                      required
                    ></b-form-input>
                  </div>
                  <br />

                  <div class="col-md-12" v-if="user_type != 'Buyer'">
                    <label for="name">Select Buyer</label>

                    <!-- <b-form-select v-model="buyer_id" id="buyer_id" name="buyer_id" placeholder="Please Select Buyer." v-validate="'required'">
                        <option :value="selected">--Select--</option>
                        <option  :value="style_list.buyer_id" v-for="style_list in buyer_arr"  >{{ style_list.buyer_name }}</option>
                    </b-form-select>  -->
                    <b-form-group>
                      <!-- <ejs-multiselect id='multiselect' placeholder="Select Buyer" v-model="buyer_id" name="buyer_arr":dataSource='buyer_arr'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" :class="{'input': true, 'is-invalid': errors.has('form-5.buyer_arr') }">
                    </ejs-multiselect>

                    <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('buyer_arr')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.buyer_arr')">{{ errors.first('form-1.buyer_arr') }}</span>
                        </b-input-group> -->
                      <div id="myapp">
                        <input
                          type="checkbox"
                          @click="checkAll()"
                          v-model="isCheckAll"
                        />
                        Check All
                        <!-- <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('buyer_id')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.buyer_id')" id="statustxt" class="help text-danger">{{ errors.first('form-1.buyer_id') }}
                        </code>
                    </b-input-group> -->
                        <table class="table col-md-12 " id="myTable">
                          <thead>
                            <tr>
                              <!-- <td>Buyer ID</td> -->
                              <td scope="col">Buyer Name</td>
                              <td scope="col">Designation</td>
                            </tr>
                          </thead>
                          <tbody v-if="buyer_response == 'Successful'">
                            <tr v-for="opt in agentmaster">
                              <!-- <td>
                                <input
                                  type="checkbox"
                                  v-bind:value="opt.buyer_id"
                                  v-model="selectedbuyers"
                                  @change="updateCheckall()"
                                />&nbsp;{{ opt.buyer_id }}
                              </td> -->
                              <!-- <td>{{ opt.buyer_name }}</td> -->
                               <td>
                                <input
                                  type="checkbox"
                                  v-bind:value="opt.buyer_id"
                                  v-model="selectedbuyers"
                                  @change="updateCheckall()"
                                />&nbsp;{{ opt.buyer_name }}
                              </td>
                              <td>{{ opt.designation }}</td>
                            </tr>
                          </tbody>
                          <tbody v-if="buyer_response == 'Unsuccessful'">
                            <tr>
                              <td colspan="3" style="text-align: center">
                                No Records Found
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('selectedbuyers')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.selectedbuyers')" id="statustxt" class="help text-danger">{{ errors.first('form-1.selectedbuyers') }}
                        </code>
                        </b-input-group> -->
                    </b-form-group>
                  </div>
                  <br />
                </b-col>
                <div slot="footer" style="margin-top: 20px">
                <b-button variant="danger"
                    class="px-4 ml-2 pull-right" @click="cancelmodal">Cancel</b-button>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="px-4 pull-right"
                    >Create Style</b-button
                  >
                  
                </div>
              </b-form>
            </b-col>
          </b-row>
          <!-- </b-col> -->

          <!-- </div> -->
        </b-form>
      </b-modal>
      <!-- Edit model ends -->
      <!-- Code For Style Add Model Ends -->

      <!-- Code for Edit Segment -->
      <b-modal
        title="Add Style Details"
        v-model="addNewStyle"
        @ok="addNewStyle = false"
      >
        <!-- <template slot="modal-header" slot-scope="{ close }">
      <h5>New Style</h5>
      </template> -->
        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-5')"
            data-vv-scope="form-5"
          >
            <b-form-group label="Style Name" :label-cols="3">
              <!-- v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.selected_style_name') }" -->
              <b-form-input
                type="text"
                name="selected_style_name"
                v-model="selected_style_name"
                placeholder="Enter Select Style Name"
                readonly
                disabled
              >
              </b-form-input>
              <!-- <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('selected_style_name')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.selected_style_name')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.selected_style_name') }}
                      </code>
                      </b-input-group> -->
            </b-form-group>

            <b-form-group label="Style Type" :label-cols="3">
                <b-input-group class="mb-3">
              <b-form-select placeholder="Select" v-model="style_type"
              required
                class="input">
                  <option value="">--Select--</option>
                  <option value="new">New</option>
                  <option value="carry forward">Carry Forward</option>
                  <option value="repeat">Repeat</option>
                  <option value="BOBS">BOBS</option>
                  <option value="vendor sample">Vendor Sample </option>
              </b-form-select>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('file_category')"
                      ></i>
                    </span>
                    <span
                      style="width:240px"
                      v-show="errors.has('form-1.file_category')"
                      class="help text-danger"
                      >{{ errors.first("form-1.file_category") }}</span
                    >
                  </b-input-group>
                </b-form-group>


              <b-form-group  label="Material" :label-cols="3"  v-if = "sub_cat != '170'">
                <b-input-group class="mb-3">
               <b-form-select v-model="material" id="material" name="material"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }" required>
                 <option :value="selected" >Select Option</option>
                 <option :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr">{{ fabrictype_list.title }}</option>
              </b-form-select> 
            </b-input-group>
               <b-input-group class="mb-3">
                <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('material')" ></i>
                </span>
                <code v-show="errors.has('form-5.material')" id="material" class="help text-danger">{{ errors.first('form-5.material') }}
                </code>
               </b-input-group>
              </b-form-select>
            </b-form-group>    
            
            



             <b-form-group label="Upper material" :label-cols="3" v-if = "sub_cat == '170'">
              <b-input-group class="mb-3">

              <b-form-select placeholder="Select" v-model="upper_material"
              required
                class="input">
                  <option value="">--Select--</option>
                  <option value="pu">PU</option>
                  <option value="pvc">PVC</option>
                  <option value="eva">EVA</option>
                  <option value="fabric">Fabric</option>
                  <option value="canvas">Canvas</option>
                  <option value="cotton">Cotton</option>
                  <option value="synthetic">Synthetic</option>
                  <option value="velvet">Velvet</option>
                  <option value="suede">Suede</option>
                  <option value="satin">Satin</option>
                  <option value="mesh">Mesh</option>
                  <option value="denim">Denim</option>
                  <option value="sequins Fabric">sequins Fabric</option>
                  <option value="glitter coated pu">Glitter coated PU</option>
                  <option value="knitted">Knitted</option>
              </b-form-select>
            </b-input-group>

              <b-input-group class="mb-3">
                <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('material')" ></i>
                </span>
                <code v-show="errors.has('form-5.material')" id="material" class="help text-danger">{{ errors.first('form-5.material') }}
                </code>
              </b-input-group>
            </b-form-group>


 
             <b-form-group label="Inner Lining" :label-cols="3" v-if = "sub_cat == '170'">
              <b-input-group class="mb-3">

              <b-form-select placeholder="Select" v-model="inner_lining"
              required
                class="input">
                  <option value="">--Select--</option>
                  <option value="synthetics">Synthetics</option>
                  <option value="wool">Wool</option>
                  <option value="satin">Satin</option>
                  <option value="suede">Suede</option>
                  <option value="poplin">Poplin</option>
                  <option value="cotton polyester">Cotton Polyester</option>
                  <option value="polyester">Polyester</option>
                  <option value="pvc">PVC</option>
                  <option value="eva">EVA</option>
                  <option value="unlined">Unlined</option>
                  <option value="pu">PU</option>
              </b-form-select>
            </b-input-group>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('file_category')"
                ></i>
              </span>
              <span
                style="width:240px"
                v-show="errors.has('form-1.file_category')"
                class="help text-danger"
                >{{ errors.first("form-1.file_category") }}</span
              >
            </b-input-group>
            </b-form-group>
            
            
            <b-form-group label="Sole" :label-cols="3" v-if = "sub_cat == '170'">
              <b-input-group class="mb-3">

              <b-form-select placeholder="Select" v-model="sole"
              required
                class="input">
                  <option value="">--Select--</option> 
                  <option value="tpr">TPR</option>
                  <option value="pu">PU</option>
                  <option value="rubber">Rubber</option>
                  <option value="eva">EVA</option>
                  <option value="tpu">TPU</option>
                  <option value="rubberized cork">Rubberized Cork</option>
                  <option value="phylon">Phylon</option>
                  <option value="thunit">Thunit</option>
                  <option value="pu mix">PU Mix</option>
                  <option value="rubber mix">Rubber Mix</option>
              </b-form-select>
            </b-input-group>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('file_category')"
                ></i>
              </span>
              <span
                style="width:240px"
                v-show="errors.has('form-1.file_category')"
                class="help text-danger"
                >{{ errors.first("form-1.file_category") }}</span
              >
            </b-input-group>
            </b-form-group>

            <b-form-group label="Surface Ornamentation" :label-cols="3" v-if = "sub_cat == '170'">
              <b-input-group class="mb-3">

              <b-form-select placeholder="Select" v-model="surface_ornamentation"
                required
                class="input">
                  <option value="">--Select--</option>
                  <option value="frill">Frill</option>
                  <option value="sequins">Sequins</option>
                  <option value="embellishment">Embellishment</option>
                  <option value="ruffles">Ruffles</option>
                  <option value="tassels">Tassels</option>
                  <option value="reverse stripes">Reverse Stripes</option>
                  <option value="tape">Tape</option>
                  <option value="shoe charms">Shoe Charms</option>
                  <option value="Printed">Printed</option>
                  <option value="Applique">Applique</option>
                  <option value="Embroidery">Embroidery</option>
                  <option value="Texture Print">Texture Print</option>
                  <option value="Quilted">Quilted</option>
                  <option value="Trim">Trim</option>
                  <option value="Buckle"> Buckle</option>
                  <option value="Bow">Bow</option>
                  <option value="NA">NA</option>
              </b-form-select>
            </b-input-group>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('file_category')"
                ></i>
              </span>
              <span
                style="width:240px"
                v-show="errors.has('form-1.file_category')"
                class="help text-danger"
                >{{ errors.first("form-1.file_category") }}</span
              >
            </b-input-group>
            </b-form-group>

           <b-form-group label="Highlight" :label-cols="3" v-if = "sub_cat == '170'">
            <b-input-group class="mb-3">
              <b-form-select placeholder="Select" v-model="highlight"
              required
                class="input">
                  <option value="">--Select--</option>
                  <option value="color block">Color block</option>
                  <option value="accent detailing">Accent detailing</option>
                  <option value="light weight">Light weight</option>
                  <option value="soft & flexible">Soft & flexible</option>
                  <option value="color changing">Color changing</option>
                  <option value="Vibrant print">Vibrant print</option>
                  <option value="Floral Appliqu">Floral Applique</option>
                  <option value="Shiny upper">Shiny upper</option>
                  <option value="Bow Detail">Bow Detail</option>
                  <option value="Saddle">Saddle</option>
                  <option value="Glittering applique">Glittering applique</option>
                  <option value="Glittering upper">Glittering upper</option>
                  <option value="Water Proof">Water Proof</option>
                  <option value="Washable">Washable</option>
                  <option value="Braided detailing"> Braided detailing</option>
                  <option value="Interlaced detailing">Interlaced detailing</option>
                  <option value="Breathable">Breathable</option>
                  <option value="Reflective detailing">Reflective detailing</option>
                  <option value="Non Marking Sole"> Non Marking Sole</option>
                  <option value="Ankle Support">Ankle Support</option>
                  <option value="Dual Density Sole">Dual Density Sole</option>
                  <option value="Studded Sole">Studded Sole</option>
                  <option value="All terrain Shoes">All terrain Shoes</option>
                  <option value="Arch Support">Arch Support</option>
                  <option value="orthopedic footbed">Orthopedic Footbed</option>
              </b-form-select>
            </b-input-group>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('file_category')"
                ></i>
              </span>
              <span
                style="width:240px"
                v-show="errors.has('form-1.file_category')"
                class="help text-danger"
                >{{ errors.first("form-1.file_category") }}</span
              >
            </b-input-group>
            </b-form-group>

            <b-form-group label="Fastening Type" :label-cols="3" v-if = "sub_cat == '170'">
              <b-input-group class="mb-3">

              <b-form-select placeholder="Select" v-model="Fastening_type"
              required
                class="input">
                  <option value="">--Select--</option>
                  <option value="slip-on">Slip-On</option>
                  <option value="lace-up">Lace-Up</option>
                  <option value="buckle">Buckle</option>
                  <option value="zip">Zip</option>
                  <option value="elastic">Elastic</option>
                  <option value="velcro">Velcro</option>
                  <option value="velcro+Elastic">Velcro + Elastic</option>
                  <option value="snap button">Snap Button</option>
              </b-form-select>
            </b-input-group>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('file_category')"
                ></i>
              </span>
              <span
                style="width:240px"
                v-show="errors.has('form-1.file_category')"
                class="help text-danger"
                >{{ errors.first("form-1.file_category") }}</span
              >
            </b-input-group>
            </b-form-group> 

<!-- 
            <b-form-group label="Grading" :label-cols="3" v-if = "sub_cat == '170'">
              <b-form-select placeholder="Select" v-model="grading"
              required
                class="input">
                  <option value="">--Select--</option>
                  <option value="A+">A+</option>
                  <option value="A">A</option>
                  <option value="B+">B+</option>
                  <option value="B">B</option>
                  <option value="C+">C+</option>
                  <option value="C">C</option>
              </b-form-select>
            </b-form-group>  -->
            <b-form-group  label="Fabric Type" :label-cols="3"  v-if = "sub_cat != '170'">
              <b-input-group class="mb-3">

                <!-- <b-form-select v-model="fabrictype" id="fabrictype" name="fabrictype"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }">
                  <option :value="selected" >Select Option</option>
                  <option :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr">{{ fabrictype_list.title }}</option>
                </b-form-select>  -->

                <b-form-select v-model="fabrictype" id="fabrictype" name="fabrictype"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }" required>
                  <option :value="selected" >Select Option</option>
                  <option value="knit">Knit</option>
                  <option value="woven">Woven</option>
                </b-form-select> 
              </b-input-group>


          
                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('fabrictype')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.fabrictype')" id="statustxt" class="help text-danger">{{ errors.first('form-5.fabrictype') }}
                  </code>
                </b-input-group>
            </b-form-group>

            <b-form-group  label="Top Fabric Type" :label-cols="3" v-if = "sub_cat != '170'">
              <b-input-group class="mb-3">

                <b-form-select v-model="top_fabric" id="top_fabric" name="top_fabric"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.top_fabric') }" required>
                  <option :value="selected" >Select Option</option>
                  <option :value="top_fabric_list.title" v-for="top_fabric_list in top_fabric_arr">{{ top_fabric_list.title }}</option>
                </b-form-select>
              </b-input-group>

                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('top_fabric')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.top_fabric')" id="statustxt" class="help text-danger">{{ errors.first('form-5.top_fabric') }}
                  </code>
                </b-input-group>
            </b-form-group>

            <b-form-group  label="Bottom Fabric Type" :label-cols="3" v-if = "sub_cat != '170'">
              <b-input-group class="mb-3">

                <b-form-select v-model="bottom_fabric" id="bottom_fabric" name="bottom_fabric" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.bottom_fabric') }" required>
                  <option :value="selected" >Select Option</option>
                  <option :value="bottom_fabric_list.title" v-for="bottom_fabric_list in bottom_fabric_arr">{{ bottom_fabric_list.title }}</option>
                </b-form-select> 
              </b-input-group>

          
                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('bottom_fabric')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.bottom_fabric')" id="statustxt" class="help text-danger">{{ errors.first('form-5.bottom_fabric') }}
                  </code>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Story Name" :label-cols="3" v-if="sub_cat != '170'">
              <b-input-group class="mb-3">
                <b-form-input
                  type="text"
                  name="selected_story_name"
                  v-model="selected_story_name"
                  placeholder="Enter Story Name 1"
                  required
                  trim
                  @input="selected_story_name = selected_story_name.replace(/^\s+|\s+$/g, '')"
                ></b-form-input>
              </b-input-group>
              <b-input-group class="mb-3">
                <span class="icon has-text-warning">
                  <i
                    class="fa fa-warning"
                    v-show="errors.has('file_category')"
                  ></i>
                </span>
                <span
                  style="width:240px"
                  v-show="errors.has('form-1.file_category')"
                  class="help text-danger"
                  >{{ errors.first("form-1.file_category") }}</span
                >
              </b-input-group>
            </b-form-group>

            <b-form-group label="Select Panton Type" :label-cols="3">
              <b-input-group class="mb-3">

              <b-form-select
                list="family-list-id"
                class="input"
                v-model="selected_panton_type"
                placeholder="Select Panton Type"
                required
                @change="
                  colortypecheck(selected_panton_type);
                  getselectedfamilycolor(selected_panton_type);
                "
              >
                <option value="">--Select--</option>
                <option value="TPG">TPG</option>
                <option value="TCX">TCX</option>
                <option value="OTHERS">OTHERS</option></b-form-select
              >

            </b-input-group>
            <b-input-group class="mb-3">
              <span class="icon has-text-warning">
                <i
                  class="fa fa-warning"
                  v-show="errors.has('file_category')"
                ></i>
              </span>
              <span
                style="width:240px"
                v-show="errors.has('form-1.file_category')"
                class="help text-danger"
                >{{ errors.first("form-1.file_category") }}</span
              >
            </b-input-group>
              <!-- {{selected_panton_type}} -->

              <!-- <datalist id="panton-list-id" required>
                      <option value="" ></option>
                      <option value="TCX">TCX</option>
                      <option value="TPX">TPX</option>
                      <option value="OTHERS">OTHERS</option>
                    </datalist> -->
            </b-form-group>

            <!-- <b-form-group 
                 label="Select Color Family"
                  :label-cols="3" 
                   id="color_family_block" style="display: none">
                    
                    <b-form-select list="family-list-id" v-model="selected_color_family"
                     placeholder="Select Color Family" v-on:change="getselectedfamilycolor(selected_color_family);" @change="familycolorcheck(selected_color_family);finalcoloroutput(0)">

                        <option :value="selected">--Select--</option>
                        <option  :value="customer.color_family" v-for="customer in color_family">{{customer.color_family }}</option>
                    </b-form-select>

                   
                  </b-form-group> -->
            <b-form-group
              label="Select Panton Color"
              :label-cols="3"
              v-model="selected_panton_color"
              style="display: none"
              id="pantom_color_block"
              required
            >
              <!--  <label for="name">Select Panton Color</label> -->
              <!-- <input placeholder="Select an Option" class="form-control" @input="setSelectedcolor" list="list" v-model="selected_pantone_no" @change="finalcoloroutput(1)"/> -->

              <!-- <b-form-select placeholder="Select an Option" class="form-control" list="list" v-model="selected_pantone_no" @change="finalcoloroutput(1);setSelectedcolor(selected_pantone_no)">
                      <option :value="selected">--Select--</option>
                        <option  :value="colorcode.pantone_no" v-for="colorcode in color_name" >{{colorcode.color_name}}&nbsp;{{colorcode.pantone_no}}</option>
                    </b-form-select> -->

              <v-select
                id="mySelect"
                v-model="selected_pantone_no"
                :options="color_name"
                name="selected_pantone_no"
                list="list"
                @change="
                  setSelectedcolor(selected_pantone_no,1);
                "
                placeholder="Select Panton Color"
              >
              </v-select>
              <!-- <datalist id="list">
                    <option v-for="colorcode in color_name" :value="colorcode.pantone_no">{{colorcode.color_name}}</option>
                  </datalist> -->
            </b-form-group>

            <b-form-group label="Selected Color"
              :label-cols="3" id="selectedcolor" v-model="Selected_Color">
              <div md="6" v-for="(color,index) in selected_final_color" class="d-flex flex-flow justify-content-between border m-1 p-1" :style="`background-color:${color.split(' ').pop()};`" :id="'color'+index">
              <span>{{color}}</span> <i class="fa fa-close" @click="()=>removecolor(index)"></i>
              </div>
              <div></div>


            </b-form-group>

            
            <!-- <b-form-group
              label="Selected Color "
              :label-cols="3"
              id="final_color_output"
              v-model="showhexcolor"
            >
           
            </b-form-group> -->

            <b-form-group
              label="Color"
              :label-cols="3"
              id="other_value_block"
              if="selected_panton_type=='OTHERS'"
            >
              <!-- v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.color') }" -->
              <b-form-input
                type="text"
                name="color"
                v-model="color"
                placeholder="Enter Hex code. e.g #111 or #ffffff"
              >
              </b-form-input>
              <!-- <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('color')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.color')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.color') }}
                      </code>
                </b-input-group> -->
            </b-form-group>

            <!-- v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-5.selected_sizeset') }" -->
            <!--  <b-form-select v-model="selected_sizeset" :options="no_of_sizeset" name="selected_sizeset" required @change="opensizesetdata(selected_sizeset)">
               
              </b-form-select>
              </b-form-group> -->
            <!-- <b-form-group> -->
            <!-- <b-form-group label="Size Range" :label-cols="3" >
              <b-row id="size_range" >
              <b-col sm="4"   style="display: inline-flex;">
              <b-form-select class="fileunit" :plain="true" name="selected_month" required v-model="range_selected_month" :options="unit_arr"  @change="range_changeMonthYearVal($event)" style="    width: 90px;">
              </b-form-select>
            </b-col>
            <b-col sm="4"  style="display: inline-flex;">
              <b-form-select class="filefromage" v-if="range_selected_month ==null"  :plain="true" name="selectedfromage" v-model="range_selectedfromage"  required :options="agefrmto_default" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }" selected >
              </b-form-select>
         
              <b-form-select class="filefromage" v-if="range_selected_month =='0'" :plain="true" name="selectedfromage"  v-model="range_selectedfromage" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
              </b-form-select>

              <b-form-select class="filefromage" v-if="range_selected_month =='1'"  :plain="true" name="selectedfromage"  v-model="range_selectedfromage" required :options="year_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
              </b-form-select>
            </b-col>
            <b-col sm="4" style="display: inline-flex;">
              <b-form-select class="filetoage" v-if="range_selected_month ==null"   :plain="true" v-model="range_selectedtoage" :options="agefrmto_default"  required>
              </b-form-select> 

              <b-form-select class="filetoage" v-if="range_selected_month =='0'"   :plain="true" v-model="range_selectedtoage" :options="to_month_arr"  required >
              </b-form-select> 

              
              <b-form-select class="filetoage" v-if="range_selected_month =='1'"   :plain="true" v-model="range_selectedtoage" :options="to_year_arr"  required >
              </b-form-select>
            </b-col>
            
            
            <b-col sm="12" style="text-align: right; margin-top: 4px"><b-button type="button" size="sm" class="mr-4 pull-right text-right" variant="primary" style="float: right;" @click="setsizeset(range_selected_month,range_selectedfromage,range_selectedtoage)" v-if="range_selectedtoage!='' && range_selectedfromage!=''">Go</b-button></b-col>
            </b-row>
          </b-form-group> -->

            <!--             <div  class="col-md-12" id="sizesetData" style="display: none;">
              
              <b-row style="overflow:auto">
                <b-form class="col-md-12" data-vv-scope="form-5">
              
                  <table class="table table-striped ">
                    <thead>
                      <tr class="fileshead">
                        <td scope="col">Size Set</td>
                        <td scope="col">Unit</td>
                        <td scope="col">Age From</td>
                        <td scope="col">Age To</td>
                      </tr>
                    </thead>
                    <tbody class="filesbody">
                      <tr v-for="(invoice_product, index) in sizeset">
                        <td class="filesize"><label >Size &nbsp;</label>{{index+1}}</td>
                        <td>
                            <b-form-select class="fileunit" :plain="true" name="selected_month" required v-model="selected_month[index]" :options="unit_arr"  @change="changeMonthYearVal($event,index)">
                            </b-form-select>
                            
                        </td>

         

                        <td>
                          <b-form-select class="filefromage" v-if="selected_month[index] ==null"  :plain="true" name="selectedfromage"  required :options="agefrmto_default" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }" selected >
                          </b-form-select>
         
                          <b-form-select class="filefromage" v-if="selected_month[index] =='0'" :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
                          </b-form-select>

                          <b-form-select class="filefromage" v-if="selected_month[index] =='1'"  :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="year_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
                          </b-form-select>               
                        </td>
                        
                        <td > 
                          <b-form-select class="filetoage" v-if="selected_month[index] ==null"   :plain="true" v-model="selectedtoage[index]" :options="agefrmto_default"  required>
                          </b-form-select> 

                          <b-form-select class="filetoage" v-if="selected_month[index] =='0'"   :plain="true" v-model="selectedtoage[index]" :options="to_month_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index)">
                          </b-form-select> 

                          <b-form-select class="filetoage" v-if="selected_month[index] =='1'"   :plain="true" v-model="selectedtoage[index]" :options="to_year_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index); ">
                          </b-form-select>

                          <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('selectedtoage')" ></i>
                              </span>
                              <code v-show="errors.has('form-5.selectedtoage')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.selectedtoage') }}
                              </code>
                          </b-input-group>

                        </td>

                       
                      </tr>
                    </tbody>

                  </table>
         
                </b-form>
                  </b-row>
                    
            </div> -->
            <!-- </b-form-group> -->

            <!-- Added Code for Size Set Ends -->

            <b-form-group label="Style Description" :label-cols="3" v-if = "sub_cat != '170'">
              <!-- v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.style_description') }" -->
              <b-form-input
                type="text"
                name="style_description"
                v-model="style_description"
                placeholder="Enter Style Description"
                required
              >
              </b-form-input>
              <!-- <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('style_description')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.style_description')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.style_description') }}
                      </code>
                </b-input-group> -->
            </b-form-group>
            <b-form-group label="Pack Of" :label-cols="3" v-if = "sub_cat != '170'">
              <b-input-group class="mb-3">

              <b-form-select v-model="pack_of" id="pack_of" name="pack_of"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.pack_of') }" required>
                <option :value="selected" >Select Option</option>
                <option :value="1" >Single</option>
                <option v-for="pack in Array.from({ length: 10 - 2 + 1 }, (_, i) => i + 2)" :value="pack">Pack of {{pack}}</option>
              </b-form-select> 
            </b-input-group>
              <b-input-group class="mb-3">
                <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('pack_of')" ></i>
                </span>
                <code v-show="errors.has('form-5.pack_of')" id="pack_of" class="help text-danger">{{ errors.first('form-5.pack_of') }}
                </code>
              </b-input-group>
            </b-form-group>

            <b-form-group label="EPP" :label-cols="3">
              <b-input-group class="mb-3">
              <b-form-select v-model="is_epp" id="is_epp" name="is_epp"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.is_epp') }">
                <option :value="selected" >Select Option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </b-form-select> 
            </b-input-group>
              <b-input-group class="mb-3">
                <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('is_epp')" ></i>
                </span>
                <code v-show="errors.has('form-5.is_epp')" id="is_epp" class="help text-danger">{{ errors.first('form-5.is_epp') }}
                </code>
              </b-input-group>
            </b-form-group>

            

            <b-form-group label="Style Comment" :label-cols="3" v-if = "sub_cat != '170'">
              <b-form-textarea
                type="text"
                name="Comment"
                v-model="style_comment"
                placeholder="Enter Style Comment"
                required
              >
              <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('Comment')" ></i>
                </span>
                <code v-show="errors.has('form-5.Comment')" id="Comment" class="help text-danger">{{ errors.first('form-5.Comment') }}
                </code>
              </b-form-textarea>
            </b-form-group>

            <!-- <b-form-group
              label="Upload File"
              class="uploadfile"
              :label-cols="3"
              v-if="check_draft_value == 0"
            > -->
              <!-- <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Upload Design File"
                accept=".pdf,.png,.jpeg,.jpg"
                @change="AddDesignimage($event)"
                required
              ></b-form-file> -->

              <!-- Code For Progress Bar -->
              <!-- <div
                class="progress1"
                id="progress_bar1"
                style="
                  display: none;
                  margin-top: 5px;
                  margin-bottom: 5px;
                  width: 100%;
                  height: 30px;
                  font-size: 18px;
                  font-weight: bold;
                "
              >
                <div
                  class="progress-bar progress-bar-info progress-bar-striped"
                  role="progressbar"
                  :aria-valuenow="progress1"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{
                    height: '30px',
                    text: '20px',
                    align: 'center',
                    width: progress1 + '%',
                  }"
                >
                  {{ progress1 }}%
                </div>
              </div> -->
              <!-- Code For Progress Bar Ends -->

              <!-- <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('file')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.file')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.file') }}
                  </code>
                </b-input-group> -->
            <!-- </b-form-group> -->
            
            <b-modal v-model="modalVisible" title="Upload File">
              
              <b-form-group
                label="Upload File" 
                class="uploadfile"
                :label-cols="3"
                v-if="check_draft_value == 0"
              >
                <!-- Drag and Drop Zone -->
                <div 
                  class="drag-drop-zone"
                  :class="{ 'drag-over': isDragging }"
                  @dragenter.prevent="handleDragEnter"
                  @dragover.prevent="handleDragOver"
                  @dragleave.prevent="handleDragLeave"
                  @drop.prevent="handleDrop"
                >
                  <div class="drag-drop-content">
                    <i class="fa fa-cloud-upload fa-3x mb-3" style="color: #20a8d8;"></i>
                    <p class="mb-2"><strong>Drag and drop your file here</strong></p>
                    <p class="text-muted mt-2" style="font-size: 0.85rem;">
                      Accepted formats: PDF, PNG, JPEG, JPG
                    </p>
                  </div>
                </div>

                <!-- Browse Button Outside Drag Zone -->
                <div class="text-center mt-3">
                  <p class="text-muted mb-2">or</p>
                  <b-form-file
                    ref="fileInput"
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Click to browse"
                    accept=".pdf,.png,.jpeg,.jpg"
                    @change="AddDesignimage($event)"
                  ></b-form-file>
                </div>

                <!-- Display selected file name -->
                <div v-if="file" class="mt-3 p-2 bg-light border rounded">
                  <i class="fa fa-file-o mr-2"></i>
                  <strong>Selected file:</strong> {{ file.name }}
                  <span class="text-muted ml-2">({{ formatFileSize(file.size) }})</span>
                </div>
               
                  <b-button
                  type="button"
                  @click="cancelUploadFilemodal()"
                  style="float: right; margin-top:20px"
                  variant="danger"
                  class="px-4"
                  >Cancel</b-button
                  >

                <!-- Code For Progress Bar -->
                <div
                  class="progress1"
                  id="progress_bar1"
                  style="
                    display: none;
                    margin-top: 5px;
                    margin-bottom: 5px;
                    width: 100%;
                    height: 30px;
                    font-size: 18px;
                    font-weight: bold;
                  "
                >
                  <div
                    class="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    :aria-valuenow="progress1"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{
                      height: '30px',
                      text: '20px',
                      align: 'center',
                      width: progress1 + '%',
                    }"
                  >
                    {{ progress1 }}%
                  </div>
                </div>
                <!-- Code For Progress Bar Ends -->

                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('file')"></i>
                  </span>
                  <code
                    v-show="errors.has('form-5.file')"
                    id="addmblnbrmsg"
                    class="help text-danger"
                  >
                    {{ errors.first('form-5.file') }}
                  </code>
                </b-input-group>
              </b-form-group>
            </b-modal>

            <b-row class="justify-content-center" style="margin-bottom:20px">
              
              <b-col md="auto" >
                 <!-- <p v-if="sampleImageurl">{{sampleImageurl}}</p> -->
                  <b-button-group>
                    
                    <b-button variant="primary" class="custom-button-width" style="width:200px;margin-right:20px" @click="showModal">Upload Tech Pack</b-button>
                    <b-button variant="secondary" class="custom-button-width"  style="width:200px" @click="createTechPack">Create Tech Pack</b-button>
                  </b-button-group>
              </b-col>
           </b-row> 
            
            <!-- <b-form-group
              label="Sample Image"
              :label-cols="3"
              v-if="check_draft_value == 0"
            >
              <b-form-file
                v-model="file1"
                :state="Boolean(file1)"
                placeholder="Upload Sample Image"
                accept="image/*"
                @change="AddSampleimage($event)"
              ></b-form-file>
            </b-form-group> -->

            <b-form-group
  label="Sample Image"
  :label-cols="3"
  v-if="check_draft_value == 0"
>
  <!-- Drag and Drop Zone -->
    <div 
      class="drag-drop-zone"
      :class="{ 'drag-over': isDraggingSample }"
      @dragenter.prevent="handleDragEnterSample"
      @dragover.prevent="handleDragOverSample"
      @dragleave.prevent="handleDragLeaveSample"
      @drop.prevent="handleDropSample"
    >
      <div class="drag-drop-content">
        <i class="fa fa-image fa-3x mb-3" style="color: #20a8d8;"></i>
        <p class="mb-2"><strong>Drag and drop sample image here</strong></p>
        <p class="text-muted mt-2" style="font-size: 0.85rem;">
          Accepted formats: PNG, JPG, JPEG
        </p>
      </div>
    </div>

    <!-- Browse Button Outside Drag Zone -->
    <div class="text-center mt-3">
      <p class="text-muted mb-2">or</p>
      <b-form-file
        ref="sampleFileInput"
        v-model="file1"
        :state="Boolean(file1)"
        placeholder="Click to browse"
        accept="image/*"
        @change="AddSampleimage($event)"
      ></b-form-file>
    </div>

    <!-- Display selected file name -->
    <div v-if="file1" class="mt-3 p-2 bg-light border rounded">
      <i class="fa fa-file-image-o mr-2"></i>
      <strong>Selected image:</strong> {{ file1.name }}
      <span class="text-muted ml-2">({{ formatFileSize(file1.size) }})</span>
    </div>
</b-form-group>

            <b-form-group
              label="Upload File"
              class="uploadfile"
              :label-cols="3"
              v-if="check_draft_value == 1"
            >
              <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Upload Design File"
                accept=".pdf,.png,.jpeg,.jpg"
                @change="AddDesignimage($event)"
                required
              ></b-form-file>
            </b-form-group>

            <b-form-group
              label="Sample Image"
              :label-cols="3"
              v-if="check_draft_value == 1"
            >
              <b-form-file
                v-model="file1"
                :state="Boolean(file1)"
                placeholder="Upload Sample Image"
                accept="image/*"
                @change="AddSampleimage($event)"
              ></b-form-file>
              <!--  -->
            </b-form-group>

            <div
              style="margin-top: 5px"
              v-if="style_list != '' && selected_style_image != ''"
            >
              <img
                v-bind:src="selected_style_image"
                id="img_uploaded"
                style="height: 100px; width: 200px"
              />
            </div>

            <!-- Code For Progress Bar -->
            <div
              class="progress"
              id="progress_bar"
              style="
                display: none;
                margin-top: 5px;
                margin-bottom: 5px;
                width: 100%;
                height: 30px;
                font-size: 18px;
                font-weight: bold;
              "
            >
              <div
                class="progress-bar progress-bar-info progress-bar-striped"
                role="progressbar"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{
                  height: '30px',
                  text: '20px',
                  align: 'center',
                  width: progress + '%',
                }"
              >
                {{ progress }}%
              </div>
            </div>
            <!-- Code For Progress Bar Ends -->
            <b-form-group label="Art Gallery" :label-cols="3">
              <a @click="seeOriginalImage()" class="pointer" style="color: blue"
                >Select from gallery</a
              >
              <img
                :v-model="file3"
                v-if="artWorkUrl != ''"
                v-bind:src="artWorkUrl"
                style="height: 80px; width: 80px"
              />

              <!--  -->
            </b-form-group>

            <div slot="footer" class="text-right">
              <b-button
                size="sm"
                variant="danger"
                class="mr-4 pull-right text-right"
                @click="newstylecancel()"
                style="float: right"
                >cancel</b-button
              >
              <b-button
                type="submit"
                size="sm"
                class="mr-4 pull-right text-right"
                variant="primary"
                style="float: right"
                @click="checkdraftvalue(0)"
                v-if="submit_enable_btn == 1"
                >Save</b-button
              >
              <b-button
                type="submit"
                size="sm"
                variant="secondary"
                class="mr-4 pull-right text-right"
                style="float: right"
                @click="checkdraftvalue(1)"
                v-if="submit_enable_btn == 1 && user_type == 'Brand_Designer'"
                >Draft Save</b-button
              >
            </div>
          </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display: none"> Cancel </b-button>
        </template>
      </b-modal>
      <div id="modal_overlay" style="display: none">
        <div class="modal_loader"></div>
        <br />
        <span class="loading" style="color: #fff">Uploading File ..</span>
      </div>
      <!-- Segment Edit Code Ends  -->
    </div>
    <!-- Edit style Modal Ends -->

    <!-- ~~~~~~~~~ imageGalleryModal starts -->
    <b-modal
      size="xl"
      title="Image Gallery"
      v-model="imageGalleryModal"
      @ok="imageGalleryModal = false"
    >
      <b-card no-body>
        <b-col class="filedesign mb-2">
          <div slot="footer" id="upload_btn">
            <b-button
              type="submit"
              style="float: right"
              variant="primary"
              class="px-4 mr-1"
              @click="selectArtWorkImage()"
              >Select Image</b-button
            >
          </div>
        </b-col>
        <b-tabs pills card>
          <b-tab
            title="All Images"
            active
            v-if="this.user_type == 'Brand_Designer'"
            @click="getGraphicsDesignListing('all', 1)"
          >
            <b-tabs pills card>
              <b-tab
                title="Shape"
                active
                @click="getGraphicsDesignListing('all', 'Shape', 1)"
              >
                <b-card-text>
                  <!-- all design for designer starts -->
                  <paginate
                    v-if="this.design_details.length > 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                  <!-- all design for designer starts -->

                  <b-row>
                    <b-col
                      md="4"
                      v-for="designs in design_details"
                      :key="designs"
                    >
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="
                            border: 1px solid #f2f2f2;
                            padding-top: 10px;
                            padding-bottom: 10px;
                          "
                        >
                          <b-col md="12" class="ml-4">
                            <input
                              class="pull-right"
                              type="radio"
                              :id="designs.artwork_id"
                              v-model="artwork_id"
                              name="fav_img"
                              :value="designs.artwork_id"
                              @click="
                                SelectImage(
                                  designs.artwork_id,
                                  designs.thumbnail_url
                                )
                              "
                            /> </b-col
                          ><br />
                          <b-col
                            md="12"
                            style="
                              background-color: #e4e5e6;
                              margin-bottom: 10px;
                            "
                          >
                            <!-- <input
                                  class="pull-right mt-2"
                                  type="radio"
                                  :id="designs.artwork_id"
                                  v-model="artwork_id"
                                  name="fav_img"
                                  :value="designs.artwork_id"
                                  @click="
                                    SelectImage(designs.artwork_id, designs.thumbnail_url)
                                  "
                                /> -->
                            <label for="name" class="mt-2"
                              ><b>{{ designs.artwork_title }}</b></label
                            >
                            <!-- <a
                                  class="pull-right mt-2"
                                  :href="designs.thumbnail_url"
                                  download
                                >
                                  <i class="fa fa-download"></i
                                ></a> -->
                          </b-col>
                          <b-col md="12">
                            <img
                              v-bind:src="designs.thumbnail_url"
                              style="height: 80px; width: 80px"
                            />
                            <!-- <div style="text-align: center;">

                                <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                                @load="imgLoadedMethod"

                                class="img_class"/>

                                

                                </div> -->
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab
                title="Pattern"
                @click="getGraphicsDesignListing('all', 'Pattern', 1)"
              >
                <b-card-text>
                  <!-- all design for designer starts -->
                  <paginate
                    v-if="this.design_details.length > 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                  <!-- all design for designer starts -->

                  <b-row>
                    <b-col
                      md="4"
                      v-for="designs in design_details"
                      :key="designs"
                    >
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="
                            border: 1px solid #f2f2f2;
                            padding-top: 10px;
                            padding-bottom: 10px;
                          "
                        >
                          <b-col md="12" class="ml-4">
                            <input
                              class="pull-right"
                              type="radio"
                              :id="designs.artwork_id"
                              v-model="artwork_id"
                              name="fav_img"
                              :value="designs.artwork_id"
                              @click="
                                SelectImage(
                                  designs.artwork_id,
                                  designs.thumbnail_url
                                )
                              "
                            /> </b-col
                          ><br />
                          <b-col
                            md="12"
                            style="
                              background-color: #e4e5e6;
                              margin-bottom: 10px;
                            "
                          >
                            <!-- <input
                                  class="pull-right mt-2"
                                  type="radio"
                                  :id="designs.artwork_id"
                                  v-model="artwork_id"
                                  name="fav_img"
                                  :value="designs.artwork_id"
                                  @click="
                                    SelectImage(designs.artwork_id, designs.thumbnail_url)
                                  "
                                /> -->
                            <label for="name" class="mt-2"
                              ><b>{{ designs.artwork_title }}</b></label
                            >
                            <!-- <a
                                  class="pull-right mt-2"
                                  :href="designs.thumbnail_url"
                                  download
                                >
                                  <i class="fa fa-download"></i
                                ></a> -->
                          </b-col>
                          <b-col md="12">
                            <img
                              v-bind:src="designs.thumbnail_url"
                              style="height: 80px; width: 80px"
                            />
                            <!-- <div style="text-align: center;">

                                <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                                @load="imgLoadedMethod"

                                class="img_class"/>

                                

                                </div> -->
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-tab>

          <!-- ~~~~~ all design for designer ends~~~~~~~ -->

          <!-- ~~~~~~~~~~~~~ uploaded by designer starts~~~~~~~~~~~~~~ -->
          <b-tab
            title="Uploaded by me"
            v-if="this.user_type == 'Brand_Designer'"
            @click="getGraphicsDesignListing('me', 1)"
          >
            <b-tabs pills card>
              <b-tab
                title="Shape"
                active
                @click="getGraphicsDesignListing('me', 'Shape', 1)"
              >
                <b-card-text>
                  <paginate
                    v-if="this.design_details.length > 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback1"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                  {{ errorMsg }}

                  <b-row>
                    <b-col
                      md="3"
                      v-for="designs in design_details"
                      :key="designs"
                    >
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="
                            border: 1px solid #f2f2f2;
                            padding-top: 10px;
                            padding-bottom: 10px;
                          "
                        >
                          <b-col md="12" class="ml-4">
                            <input
                              class="pull-right"
                              type="radio"
                              :id="designs.artwork_id"
                              v-model="artwork_id"
                              name="fav_img"
                              :value="designs.artwork_id"
                              @click="
                                SelectImage(
                                  designs.artwork_id,
                                  designs.thumbnail_url
                                )
                              "
                            /> </b-col
                          ><br />
                          <b-col
                            md="12"
                            style="
                              background-color: #e4e5e6;
                              margin-bottom: 10px;
                            "
                          >
                            <label for="name" class="mt-2"
                              ><b>{{ designs.artwork_title }}</b></label
                            >
                            <!-- <a
                              class="pull-right mt-2"
                              :href="designs.thumbnail_url"
                              download
                            >
                              <i class="fa fa-download"></i 
                            ></a>-->
                          </b-col>
                          <b-col md="12">
                            <img
                              v-bind:src="designs.thumbnail_url"
                              style="height: 80px; width: 80px"
                            />
                            <!-- <div style="text-align: center;">

                            <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                            @load="imgLoadedMethod"

                            class="img_class"/>

                            

                            </div> -->
                          </b-col>
                          <b-col>
                            <b
                              v-if="
                                designs.original_image_by != null &&
                                designs.original_image_by != ''
                              "
                              >Original Image:
                              {{ designs.original_image_by }}</b
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col md="3">
                    <b-form-group>
                      <b-col
                        md="12"
                        class="pull-left"
                        style="border:1px solid #F2F2F2; padding-top:10px; padding-bottom:10px;"
                      >
                        <b-col
                          md="12"
                          style="background-color:#E4E5E6; margin-bottom:10px;"
                        >
                          <label for="name" class=" mt-2"
                            ><b>
                              Image Name
                            </b></label
                          >
                          <a class="pull-right mt-2">
                            <i class="fa fa-download"></i
                          ></a>
                        </b-col>
                        <b-col
                          md="12"surface_ornamentation
                          style="background-color:#E4E5E6; margin-bottom:10px;"
                        >
                        </b-col>
                        <b-col md="12">
                          <img
                            src="/img/navy_smiley.jpg"
                            style="height:200px; width:200px;"
                          />
                        </b-col>
                        <b-col>
                          <a @click="seeOriginalImage()" class="pointer"
                            ><b>Original Image</b></a
                          >
                        </b-col>
                      </b-col>
                    </b-form-group>
                  </b-col>
                  -->
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab
                title="Pattern"
                @click="getGraphicsDesignListing('me', 'Pattern', 1)"
              >
                <b-card-text>
                  <paginate
                    v-if="this.design_details.length > 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback1"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                  {{ errorMsg }}

                  <b-row>
                    <b-col
                      md="4"
                      v-for="designs in design_details"
                      :key="designs"
                    >
                      <b-form-group>surface_ornamentation
                        <b-col
                          md="12"
                          class="pull-left"
                          style="
                            border: 1px solid #f2f2f2;
                            padding-top: 10px;
                            padding-bottom: 10px;
                          "
                        >
                          <b-col md="12" class="ml-4">
                            <input
                              class="pull-right"
                              type="radio"
                              :id="designs.artwork_id"
                              v-model="artwork_id"
                              name="fav_img"
                              :value="designs.artwork_id"
                              @click="
                                SelectImage(
                                  designs.artwork_id,
                                  designs.thumbnail_url
                                )
                              "
                            /> </b-col
                          ><br />
                          <b-col
                            md="12"
                            style="
                              background-color: #e4e5e6;
                              margin-bottom: 10px;
                            "
                          >
                            <label for="name" class="mt-2"
                              ><b>{{ designs.artwork_title }}</b></label
                            >
                            <!-- <a
                                class="pull-right mt-2"
                                :href="designs.thumbnail_url"
                                download
                              >
                                <i class="fa fa-download"></i 
                              ></a>-->
                          </b-col>
                          <b-col md="12">
                            <img
                              v-bind:src="designs.thumbnail_url"
                              style="height: 80px; width: 80px"
                            />
                            <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                          </b-col>
                          <b-col>
                            <b
                              v-if="
                                designs.original_image_by != null &&
                                designs.original_image_by != ''
                              "
                              >Original Image:
                              {{ designs.original_image_by }}</b
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-tab>
          <!-- ~~~~~~~~~~~~~~ uploaded by designer ends  ~~~~~~~~~~~~~~~~~~~-->

          <!-- ~~~~~~~~~~~~~ edited starts~~~~~~~~~~~~~~ -->
          <b-tab
            title="Edited Design"
            v-if="this.user_type == 'Brand_Designer'"
            @click="getGraphicsDesignListing('edited', 1)"
          >
            <b-tabs pills card>
              <b-tab
                title="Shape"
                active
                @click="getGraphicsDesignListing('edited', 'Shape', 1)"
              >
                <b-card-text>
                  <paginate
                    v-if="this.design_details.length > 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback2"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                  {{ errorMsg }}

                  <b-row>
                    <b-col
                      md="4"
                      v-for="designs in design_details"
                      :key="designs"
                    >
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="
                            border: 1px solid #f2f2f2;
                            padding-top: 10px;
                            padding-bottom: 10px;
                          "
                        >
                          <b-col md="12" class="ml-4">
                            <input
                              class="pull-right"
                              type="radio"
                              :id="designs.artwork_id"
                              v-model="artwork_id"
                              name="fav_img"
                              :value="designs.artwork_id"
                              @click="
                                SelectImage(
                                  designs.artwork_id,
                                  designs.thumbnail_url
                                )
                              "
                            /> </b-col
                          ><br />
                          <b-col
                            md="12"
                            style="
                              background-color: #e4e5e6;
                              margin-bottom: 10px;
                            "
                          >
                            <label for="name" class="mt-2"
                              ><b>{{ designs.artwork_title }}</b></label
                            >
                            <!-- <a
                                class="pull-right mt-2"
                                :href="designs.thumbnail_url"
                                download
                              >
                                <i class="fa fa-download"></i 
                              ></a>-->
                          </b-col>
                          <b-col md="12">
                            <img
                              v-bind:src="designs.thumbnail_url"
                              style="height: 80px; width: 80px"
                            />
                            <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                          </b-col>
                          <b-col>
                            <b
                              v-if="
                                designs.original_image_by != null &&
                                designs.original_image_by != ''
                              "
                              ><a
                                @click="
                                  seeOriginalImageedited(designs.original_image)
                                "
                                class="pointer"
                                >Original Image:
                                {{ designs.original_image_by }}</a
                              ></b
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col md="3">
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="border:1px solid #F2F2F2; padding-top:10px; padding-bottom:10px;"
                        >
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                            <label for="name" class=" mt-2"
                              ><b>
                                Image Name
                              </b></label
                            >
                            <a class="pull-right mt-2">
                              <i class="fa fa-download"></i
                            ></a>
                          </b-col>
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                          </b-col>
                          <b-col md="12">
                            <img
                              src="/img/navy_smiley.jpg"
                              style="height:200px; width:200px;"
                            />
                          </b-col>
                          <b-col>
                            <a @click="seeOriginalImage()" class="pointer"
                              ><b>Original Image</b></a
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    -->
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab
                title="Pattern"
                @click="getGraphicsDesignListing('edited', 'Pattern', 1)"
              >
                <b-card-text>
                  <paginate
                    v-if="this.design_details.length > 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback2"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                  {{ errorMsg }}

                  <b-row>
                    <b-col
                      md="4"
                      v-for="designs in design_details"
                      :key="designs"
                    >
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="
                            border: 1px solid #f2f2f2;
                            padding-top: 10px;
                            padding-bottom: 10px;
                          "
                        >
                          <b-col md="12" class="ml-4">
                            <input
                              class="pull-right"
                              type="radio"
                              :id="designs.artwork_id"
                              v-model="artwork_id"
                              name="fav_img"
                              :value="designs.artwork_id"
                              @click="
                                SelectImage(
                                  designs.artwork_id,
                                  designs.thumbnail_url
                                )
                              "
                            /> </b-col
                          ><br />
                          <b-col
                            md="12"
                            style="
                              background-color: #e4e5e6;
                              margin-bottom: 10px;
                            "
                          >
                            <label for="name" class="mt-2"
                              ><b>{{ designs.artwork_title }}</b></label
                            >
                            <!-- <a
                                class="pull-right mt-2"
                                :href="designs.thumbnail_url"
                                download
                              >
                                <i class="fa fa-download"></i 
                              ></a>-->
                          </b-col>
                          <b-col md="12">
                            <img
                              v-bind:src="designs.thumbnail_url"
                              style="height: 80px; width: 80px"
                            />
                            <!-- <div style="text-align: center;">

                              <v-lazy-image v-bind:src="designs.style_image" :class="imgIsLoaded ? 'show' : ''" loading="lazy"

                              @load="imgLoadedMethod"

                              class="img_class"/>

                              

                              </div> -->
                          </b-col>
                          <b-col>
                            <b
                              v-if="
                                designs.original_image_by != null &&
                                designs.original_image_by != ''
                              "
                              ><a
                                @click="
                                  seeOriginalImageedited(designs.original_image)
                                "
                                class="pointer"
                                >Original Image:
                                {{ designs.original_image_by }}</a
                              ></b
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col md="3">
                      <b-form-group>
                        <b-col
                          md="12"
                          class="pull-left"
                          style="border:1px solid #F2F2F2; padding-top:10px; padding-bottom:10px;"
                        >
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                            <label for="name" class=" mt-2"
                              ><b>
                                Image Name
                              </b></label
                            >
                            <a class="pull-right mt-2">
                              <i class="fa fa-download"></i
                            ></a>
                          </b-col>
                          <b-col
                            md="12"
                            style="background-color:#E4E5E6; margin-bottom:10px;"
                          >
                          </b-col>
                          <b-col md="12">
                            <img
                              src="/img/navy_smiley.jpg"
                              style="height:200px; width:200px;"
                            />
                          </b-col>
                          <b-col>
                            <a @click="seeOriginalImage()" class="pointer"
                              ><b>Original Image</b></a
                            >
                          </b-col>
                        </b-col>
                      </b-form-group>
                    </b-col>
                    -->
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-tab>
          <!-- ~~~~~~~~~~~~~~ Edited ends  ~~~~~~~~~~~~~~~~~~~-->
        </b-tabs>
      </b-card>

      <b-col class="filedesign">
        <div slot="footer" id="upload_btn">
          <b-button
            type="button"
            @click="cancelmodalimage()"
            style="float: right"
            variant="danger"
            class="px-4"
            >Cancel</b-button
          >
          <b-button
            type="submit"
            style="float: right"
            variant="primary"
            class="px-4 mr-1"
            @click="selectArtWorkImage()"
            >Select Image</b-button
          >
        </div>
      </b-col>
    </b-modal>
    <!-- ~~~~~~~~~~~~ imageGalleryModalEnds -->

    <!-- ~~~~~~~~~ originalImageModal starts -->
    <b-modal
      title="Original Image"
      v-model="originalImageModal"
      @ok="originalImageModal = false"
    >
      <b-col class="filedesign">
        <b-col sm="12">
          <b-form-group>
            <!-- <label class="ml-3"><b>Image Name</b></label> -->
            <b-col md="12">
              <img
                v-bind:src="this.origin_image_name"
                class="mb-3"
                style="height: 200px; width: 200px"
              />
            </b-col>
            <!-- <p class="ml-3"><b>Uploaded By:-</b> ABCD</p>
            <p class="ml-3"><b>Uploaded Date:-</b> 18/04/2023</p> -->
          </b-form-group>
        </b-col>
        <div slot="footer" id="upload_btn">
          <b-button
            type="button"
            @click="cancelmodalimageedited()"
            style="float: right"
            variant="danger"
            class="px-4"
            >Cancel</b-button
          >
        </div>
      </b-col>
    </b-modal>
    <!-- ~~~~~~~~~~~~ originalImageModalEnds -->
  </div>
</template>

<!-- </div>
</template> -->

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";

const axios = require("axios");

const SIZE = 10 * 1024 * 1024;

const Status = {
  wait: "wait",
  pause: "pause",
  uploading: "uploading",
};

export default {
  name: "Cards",
  data: function () {
    return {
// dynamicHtml: "<p>dynamic html will be here</p>",
      sampelAddModal: false,
      addNewDesign: false,
      addNewStyle: false,
      show: true,
      isCollapsed: true,
      style_list: [],
      collection_title: "",
      Design_Name: "",
      Design_Id: "",
      url_path: "",
      collection_category: "",
      collection_subcategory: "",
      subcatlist: [],
      collection_Id_txt: "",
      collection_id_edit: 0,
      collection_title_edit: "",
      file3: "",

      no_of_sizeset: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
      ],

      //new added code
      //new added code
      remoteUrl: "",
      image: "",

      collection_id: 0,
      design_categoty_id: 0,
      style_name: "",
      style_description: "",
      segment_id: 0,
      design_subcategoty_id: 0,
      po_typearr: [],
      // sub_cat_arr:[],
      buyer_arr: [],
      utility_type_arr: [],
      //no_of_units_in_pack: 0,
      no_of_colors: 0,
      //no_of_sizeset: 0,
      created_by: "",
      upload_image: "",
      style_image: "",
      selectedPO_type: null,
      selectedpack: null,
      selectedutility_type: null,
      selected_sub_category: null,
      color: "",
      createPO_type: null,
      design_title: "",
      selcted_design_title: "",
      sub_category: "",
      pantonColorSel: "",
      generated_design_id: "",
      style_id: "",
      style_code: "",
      selected_sizeset: null,
      selected_segment: 1,
      file: "",
      temp_img: "",
      selected: "",
      sub_catid: 0,
      buyer_id: 0,
      sub_cattitle: "",
      sub_cat: [],
      po_id: "",
      selected_style_name: "",
      selected_story_name: "",
      potype_title: "",
      segment_title: "",
      utility_id: 0,
      utilitytype_title: "",
      collection_details: [],
      selected_collectionid: 0,
      selected_brandid: 0,
      collection_subcatid: 0,
      collection_po_id: 0,
      collection_segment_id: 0,
      user_type: "",
      user: 0,
      selected_buyer_id: 0,
      user_result: [],
      sub_cat_id_arr: [],
      selected_utility_id: 0,
      selected_po_id: 0,
      selected_subcat_id: 0,
      selected_sub_cat_id: 0,
      editstyleModal: false,

      selected_po_tab: 0,
      selected_subcat_tab: 0,
      selected_utility_tab: 0,

      //new end

      // Panton color
      colortype: {},
      customer: {},
      colorcode: {},
      color_name: [],
      color_family: [],
      pantoncolor: [],
      showhexcolor: "",
      pantonno_result: [],
      showcolorname: "",
      // SelectPantonType:'',
      selectedpanton: "",
      //temp code
      po_type: "",
      utility_type: "",
      // sub_cat: 'Sweat Shirts & Jackets',
      // segment: 'Boy',
      style_code: "",
      agentfields: { text: "buyer_name", value: "buyer_id" },
      showSelectAll: true,
      allowCustomValue: true,
      uploadedfile: "",
      selectFiletype: "",
      sytleImageurl: "",
      stylePdfUrl: "",
      sampleFile: "",
      sampleImageurl: "",
      selected_draft_value: 0,
      progress: 0,
      selected_style_id: 0,
      check_draft_value: 0,
      selected_style_image: "",
      draft_flag: 0,
      s_image: "",
      buyer_response: "",
      selectedbuyer_length: 0,
      selectedbuyers: [],
      isCheckAll: false,
      agentmaster: [],
      result_data: [],
      resuld_data_msg: "",
      count_data: [],
      style_data: [],
      sizeset: [],
      invoice_products: [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ],
      range_selectedfromage: [],
      temp_range_selectedfromage: [],
      range_selectedtoage: [],
      selected_month: [],
      range_selected_month: [],
      selected_age: 0,
      selectedfromage: [],
      selectedtoage: [],
      quantity: [],
      unit: [],
      factorysize: [],
      month_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      year_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
      ],
      to_month_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      to_year_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
      ],
      agefrmto_default: [{ value: "", text: "-- Select --" }],
      factorysize: [],
      unit_arr: [
        { value: "0", text: "Month" },
        { value: "1", text: "Year" },
      ],
      index: 1,
      age_from: [],
      //age_to: [],
      age_to: [],
      total_quantity: 0,
      sizesetselect: false,
      colorcheck: "",
      color_family: "",
      pantone_no: "",
      panton_type: "",
      selected_color_family: "",
      temp_selected_color_family: "",
      selected_pantone_no: "",
      selected_panton_type: "",
      selected_panton_color:"",
      story_name: "",
      temp_selected_panton_type: "",
      selected_color: '',
      selected_final_color: [],
      selected_final_color1:'',
      other_value: "",
      temp_unit: [],
      temp_from_age: [],
      temp_to_age: [],
      temp_index: [],
      submit_enable_btn: 1,
      progress: "",
      progress1: "",
      imageGalleryModal: false,
      design_details: [],
      keyword: "all",
      type: "Shape",
      user_id: "",
      artWorkId: "",
      artWorkUrl: "",
      originalImageModal: false,
      origin_image_name: "",
      errorMsg: "",
      noofpages: "",
      total_records: [],
      count_arr: [],
      total_design_rows: 0,
      pageNo: 1,
      //temp code ends

      // large file upload variables
      container: {
        file: null,
        hash: "",
        worker: null,
        filename: null,
      },
      data: [],
      requestList: [],
      style_type:"",
      yctype:'',
      fabrictype:"",
      bottom_fabric:'',
      bottom_fabric_arr:[],
      top_fabric:'',
      top_fabric_arr:[],
      fabrictype_arr:[],
      selected_brand_id:"",
      material: '',
      pack_of:'',
      is_epp: '',
      selectedDeleteId:'',
      style_comment: '',
     //upload techpack 
      modalVisible: false,
      isDragging: false,
      isDraggingSample: false,
      po_type:'',
      upper_material:'',
      inner_lining:'',
      sole:'',
      surface_ornamentation:'',
      highlight:'',
      Fastening_type:'',
      Footwear_last_code:''
    };
  },
  //New lazyLoading
  // mounted(){
  //   window.scrollTo(0,0);
  //   window.addEventListener("scroll",this.lazyLoad);
  // },
  //ends LazyLoading
  created: function () {
    if (this.$route.params) {
      console.log(this.$route.params)
    }
    // this.getusersdetails();
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    // this.sub_cat_id_arr = userInfo[0].subcat_assign;
    this.user_type = userInfo[0].user_type;
    this.user_id = userInfo[0].user_id;
    localStorage.setItem('formData', JSON.stringify({}));
    // this.getStyleList();

    // this.getSubCategoryList();
    this.getUserRestrictedSubCat(this.$route.params.user_id,this.$route.params.cat_id,this.$route.params.brand_id)

    this.vendor_id = userInfo[0].vendor_id;
    this.selected_collectionid = this.$route.params.id;

    this.getbuyerlist();
    this.getcollectiondetails();
    this.getcolorfamilylist();
    if (this.user_type == "Brand_Designer") {
      this.keyword = "all";
      this.type = "Shape";
      this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
    } else if (this.user_type == "Graphics_Designer") {
      this.keyword = "me";
      this.type = "Shape";
      this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
    }
  },

  methods: {

    handleEventDelegationForDeleteBtn: function(){
      // alert();
      let deleteButtons = document.getElementsByClassName('deletestylebtn')
      console.log('deleteButtons------>',deleteButtons)
      for(let i=0;i<deleteButtons.length;i++){
        console.log('deletButton '+i+'---------->'+deleteButtons[i])
        deleteButtons[i].addEventListener('click',()=>{
          console.log('clicked delete button')
          this.deleteStyle(deleteButtons[i].dataset.styleId)
        })
      }
    },
    deleteStyle: function (id){
      this.selectedDeleteId= id
      console.log('deleteStyle------>',id)
      this.$fire({
        title: "Are you sure you want to delete this style?",  
        type: "warning",
        timer: 30000,
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "OK",
        preConfirm: () => {
          // Function to call when OK button is clicked
          this.okFunction();
        },
        didDismiss: (dismissalType) => {
          if (dismissalType === "cancel" || dismissalType === "backdrop") {
            // Function to call when Cancel button is clicked or outside of modal area is clicked
              cancelFunction();
            }
          }
        });
    },

    okFunction() {
        // Your logic for the OK button
        console.log("OK button clicked");
        document.getElementById("overlay").style.display = "block";
          const obj = {
              style_id : this.selectedDeleteId
          }
          console.log(obj) 
          axios
            .post(`${CONSTANTS.API_URL}/deleteStyle`, obj)
            .then((response) => {
              console.log("deletestyle1111111111", response.data)
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                      // Close the accordion
                
                this.$fire({
                      text: "Style Deleted Successfully",
                      type: "success",
                      timer: 30000,
                });
                //this.showstyledetails(this.generated_design_id) 
                 this.closeAccordion()

              }
            })
      },


    // Method to close the accordion
        closeAccordion() {
        console.log("inaccordinom")
        // Find all accordion elements
        const accordions = document.querySelectorAll(".accordion .collapse.show");
        accordions.forEach((accordion) => {
            accordion.classList.remove("show");
        });
        },

      cancelFunction() {
        // Your logic for the Cancel button
        console.log("Cancel button clicked");
        // Call any other function specific to Cancel button
      },

    setsizeset: function (unit, from_age, to_age) {
      console.log("unit--->", unit);
      console.log("from_age--->", from_age);
      console.log("to_age", to_age);
      this.invoice_products[0].unit = [];
      this.invoice_products[0].selectedfromage = [];
      this.invoice_products[0].selectedtoage = [];
      this.invoice_products = [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ];
      //   this.selected_month= [];
      //   this.selected_age= 0;
      //   this.selectedfromage=[];
      //   this.selectedtoage= [];
      //   this.quantity= [];
      //   this.factorysize= [];
      this.range_selected_month = "";
      this.range_selectedtoage = 0;
      this.range_selectedfromage = 0;

      this.range_selectedtoage = to_age;
      this.range_selectedfromage = from_age;
      this.range_selected_month = unit;

      if (parseInt(from_age) < parseInt(to_age)) {
        this.selected_sizeset =
          this.range_selectedtoage - this.range_selectedfromage;
        this.temp_range_selectedfromage = this.range_selectedfromage;
        for (var i = 1; i <= this.selected_sizeset; i++) {
          this.invoice_products[0].unit.push(unit);
          this.invoice_products[0].selectedfromage.push(
            this.temp_range_selectedfromage
          );
          this.invoice_products[0].selectedtoage.push(
            parseInt(this.temp_range_selectedfromage) + 1
          );
          this.temp_range_selectedfromage =
            parseInt(this.temp_range_selectedfromage) + 1;
        }
        console.log("this.invoice_products-------->>>", this.invoice_products);
        for (var i = 0; i <= this.selected_sizeset; i++) {
          this.selected_month[i] = this.invoice_products[0].unit[i];
          this.selectedfromage[i] = this.invoice_products[0].selectedfromage[i];
          this.selectedtoage[i] = this.invoice_products[0].selectedtoage[i];
          this.temp_index.push(i);
        }

        this.opensizesetdata(this.selected_sizeset);
        this.temp_unit.push(this.invoice_products[0].unit);
        this.temp_from_age.push(this.invoice_products[0].selectedfromage);
        this.temp_to_age.push(this.invoice_products[0].selectedtoage);
        this.temp_index.push(this.temp_index);
        this.submit_enable_btn = 1;
        // for(var i=0;i<=this.selected_sizeset; i++){
        //    //   alert("In");
        //      this.invoice_products[0].unit.push(unit);
        //      this.invoice_products[0].selectedfromage.push(from_age);
        //      this.invoice_products[0].selectedtoage.push(to_age);

        //    }
        //    this.calculateTotalQuantity(this.temp_unit,this.temp_from_age,this.temp_to_age,this.temp_index);
        // this.AddDesignfunction();
      } else if (parseInt(from_age) >= parseInt(to_age)) {
        this.$fire({
          text: "Age To Value Should Be Greater Than Age From Value.",
          type: "warning",
          timer: 30000,
        });
        this.selected_sizeset = null;
        unit = 0;
        from_age = 0;
        to_age = 0;
        // this.selected_sizeset=null;
        this.invoice_products[0].unit = [];
        this.invoice_products[0].selectedfromage = [];
        this.invoice_products[0].selectedtoage = [];
        this.invoice_products = [
          {
            unit: [],
            selectedfromage: [],
            selectedtoage: [],
            quantity: [],
            factorysize: [],
          },
        ];
        // this.range_selected_month= '';
        // this.range_selectedtoage=0;
        // this.range_selectedfromage=0;
      }

      // for(var i=0;i<=this.selected_sizeset; i++){
      //    //   alert("In");
      //      this.invoice_products[0].unit.push(unit);
      //      this.invoice_products[0].selectedfromage.push(from_age);
      //      this.invoice_products[0].selectedtoage.push(to_age);

      //    }
    },
    finalcoloroutput: function (value) {
      // alert("Innnnnn")
      if (value == 1) {
        document.getElementById("final_color_output").style.display = "block";
      } else {
        document.getElementById("final_color_output").style.display = "none";
      }
    },
    colortypecheck: function (value) {
      // this.selected_color_family='';
      this.selected_pantone_no = "";
      this.colorcheck = value;
      if (value != "OTHERS" && value != "") {
        document.getElementById("pantom_color_block").style.display = "block";
        document.getElementById("other_value_block").style.display = "none";
        document.getElementById("selectedcolor").style.display = "block";

      } else {
        // this.selected_color_family='';
        this.selected_pantone_no = "";
        this.other_value = value;

        if (value == "OTHERS") {
          document.getElementById("other_value_block").style.display = "block";
          // document.getElementById('color_family_block').style.display="none";
          document.getElementById("pantom_color_block").style.display = "none";
          document.getElementById("selectedcolor").style.display = "none";
          
        }
      }
    },
    familycolorcheck: function (value) {
      this.selected_pantone_no = "";
      if (value != "") {
        document.getElementById("pantom_color_block").style.display = "block";
      } else {
        this.selected_color_family = "";
        this.selected_pantone_no = "";
        this.selected_panton_type = "";
        document.getElementById("pantom_color_block").style.display = "none";
      }
    },
    opensizesetdata: function (value) {
      document.getElementById("size_range").style.display = "block";
      this.sizeset = [];
      for (var i = 0; i < value; i++) {
        this.sizeset.push(i);
      }

      document.getElementById("sizesetData").style.display = "block";
      // this.AddDesignfunction();
    },
    checkagevalue(from_age, to_age, index) {},

    calculateTotalQuantity: function () {
      // var unit=[];
      // var from_age=[];
      // var to_age=[];
      // this.selected_sizeset= 0;
      this.invoice_products = [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ];
      //  for(var i=0;i<=this.selected_sizeset; i++){
      //   this.invoice_products[0].unit.push(unit);
      //   this.invoice_products[0].selectedfromage.push(from_age);
      //   this.invoice_products[0].selectedtoage.push(to_age);

      // }

      // if(this.selected_sizeset==unit.length && this.selected_sizeset==from_age.length && this.selected_sizeset==to_age.length){
      //   this.AddDesignfunction();
      // }
      // else{
      //   this.$fire({
      //       text:"Please Select All Size Set Values.",
      //       type: "warning",
      //       timer: 30000
      //       })
      // }
      // alert("In")
      this.AddDesignfunction();
    },

    // Change Drop Down Value for Month & Year By Prasad
    range_changeMonthYearVal: function (value_for) {
      if (value_for == 0) {
        //month
        //this.age_from[index] ="";
        this.age_from = this.year_arr;
        this.selectedfromage = this.year_arr;
      } else {
        this.age_from = this.month_arr;
        this.selectedfromage = this.year_arr;
      }
    },
    // Change Drop Down Value for Month & Year By Prasad
    changeMonthYearVal: function (value_for, index) {
      if (value_for == 0) {
        //month
        //this.age_from[index] ="";
        this.age_from[index] = this.year_arr;
        this.selectedfromage[index] = this.year_arr;
      } else {
        this.age_from[index] = this.month_arr;
        this.selectedfromage[index] = this.year_arr;
      }
    },

    showstyledetails: function (selected_design_id) {
      document.getElementById("overlay").style.display = "block";
      // var temp= document.getElementById(selected_design_id).innerHTML = "Paragraph changed!";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.isBusy = true;
      const Obj = {
        collection_id: this.$route.params.id,
        user_type: userInfo[0].user_type,
        user_id: userInfo[0].user_id,
        buyer_id: userInfo[0].user_id,
        po_id: this.selected_po_id,
        utility_id: this.selected_utility_id,
        sub_catid: this.selected_subcat_id,
        design_id: selected_design_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getOnDemandStyleListHTML`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            // this.style_data  = this.result.returnvalue[0];
            this.style_data_html = this.result.returnvalue[0].style_list;
            console.log("this.style_data_html",this.style_data_html)
            document.getElementById("design_" + selected_design_id).innerHTML =
              this.style_data_html;
            this.handleEventDelegationForDeleteBtn();
          } else {
            this.count_data = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
        console.log('showstyledetails------->',e)
          // this.errors.push(e);
          
        });
    },

    /****** Function to get count for design ********/
    getDesignWithStyleCount: function (poid, utilityid, subcatid) {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.isBusy = true;
      const Obj = {
        collection_id: this.$route.params.id,
        user_type: userInfo[0].user_type,
        user_id: userInfo[0].user_id,
        buyer_id: userInfo[0].user_id,
        po_id: poid,
        utility_id: utilityid,
        sub_catid: subcatid,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getDesignWithStyleCount`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          this.resuld_data_msg = this.result.returnmsg;
          if (this.result.returnmsg === "Successful") {
            this.count_data = this.result.returnvalue;
            this.selected_brand_id = this.result.returnvalue[0].brand_id;
            this.selected_utility_tab = utilityid;
          } else {
            this.count_data = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    /****** Function to get count for design ends********/

    // Fabric type api

      fabrictypefunation : function(){
        // alert();
        const Obj={
          subcat_id: this.selected_subcat_id,
          // brand_id: this.selected_brand_id,
          // style_id: this.selected_style_id
        }
        axios.post(`${CONSTANTS.API_URL}/getFabricTypeList`,Obj)
           .then(response => {

            document.getElementById("overlay").style.display = "none";
             this.result = response.data;
             if (this.result.returnmsg === 'Successful') {
              //  this.fabric_arr=this.result.returnvalue[0].Fabric;
               this.fabrictype_arr = this.result.returnvalue[0].FabricType;
               this.bottom_fabric_arr = this.result.returnvalue[0].Bottom_Fabric_Sole_Material;
               this.top_fabric_arr = this.result.returnvalue[0].Top_Fabric_Upper_Fabric;
              
             }else {
              this.fabrictype_arr =[]
             
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })      

      
       },

    // Fabric type api end

    // new lazyLoading
    //     lazyLoad: function () {
    //   let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    //   let active = false;
    //   if (active === false) {
    //     active = true;
    //     setTimeout(() => {
    //       lazyImages.forEach(function (lazyImage) {
    //         if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
    //           lazyImage.src = lazyImage.dataset.src;
    //           lazyImage.classList.remove("lazy");
    //           lazyImages = lazyImages.filter(function (image) {
    //             return image !== lazyImage;
    //           });

    //           if (lazyImages.length === 0) {
    //             window.removeEventListener("scroll", this.lazyLoad);
    //           }
    //         }
    //       });
    //       active = false;
    //     }, 200)

    //   }

    // },
    // end lazyLoading

    /*************Panton color Function**************/
    getcolorfamilylist: function (value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const Obj = { color_type: "TPG" };
      axios
        .post(`${CONSTANTS.API_URL}/getcolorfamilylist`, Obj)
        .then((result) => {
          if (result.data.returnmsg === "Successful") {
            this.color_family = result.data.returnvalue;
          } else {
            this.color_family = [];
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    getselectedfamilycolor: function (color) {
       document.getElementById("overlay").style.display = "block";
      const Obj = {
        color_family: color,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getlistagainstcolorfamily`, Obj)
        .then((result) => {
          this.result1 = result.data;
          if (this.result1.returnmsg === "Successful") {
             document.getElementById("overlay").style.display = "none";
            this.color_name = this.result1.returnvalue;
            var data = [];

            this.color_name.forEach(function (srData) {
              data.push({
                key: srData.pantone_no,
                label: srData.color_name + " - " + srData.pantone_no,
              });
            });
            this.color_name = data;
          } else {
            document.getElementById("overlay").style.display = "none";
            this.color_name = [];
          }
        });
    },
    setSelectedcolor: function (value,checked_val) {
      console.log("Vallllll", value.key);
      console.log("checked_val", checked_val);
      // var x=document.getElementById('opt').style.backgroundColor=opt.value;
      // .style.backgroundColor=colorData;
      // document.body.style.backgroundColor =  colorData;

      // var colorData='12-6204 TCX'
       document.getElementById("overlay").style.display = "block";
        if (checked_val == 0) {
        var Obj = {
          pantone_no: value,
        };
      } else {
        var Obj = {
          pantone_no: value.key,
        };
      }
      axios
        .post(`${CONSTANTS.API_URL}/getlistagainstpantonno`, Obj)
        .then((result) => {
          this.pantonno_result = result.data;
          if (this.pantonno_result.returnmsg === "Successful") {
             document.getElementById("overlay").style.display = "none";
            this.pantoncolor = this.pantonno_result.returnvalue;
          
            this.showhexcolor = this.pantoncolor[0].hex_code;
            this.showcolorname = this.pantoncolor[0].color_name;
            this.selected_final_color1 =
            this.showcolorname + " " + this.showhexcolor;

            this.selected_final_color.push(this.selected_final_color1)
            console.log("~~~~~~@@@@@@@@@@@@@@@@@@@@@@@@@~~~~~~~~~~~~~~~")
            console.log("#############", this.selected_final_color)

          } else {
            this.pantoncolor = [];
            this.selected_final_color = [];
          }
        });
    },
    /****** Panton Function end  *****/

    // Remove color
    removecolor(index){
      console.log(index)
      this.selected_final_color.splice(index,1)
      console.log("**************************")
      console.log(this.selected_final_color)
    },

    draftvaluefunction(value) {
      this.selected_draft_value = value;
    },

    myFunction: function () {
      var input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toUpperCase();
      table = document.getElementById("myTable");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },

    addNewDesignmodel() {
      this.design_title = "";
      this.selected_buyer = "";
      this.selectedbuyers = []
      this.addNewDesign = !this.addNewDesign;
      console.log(' this.addNewDesign !!!!', this.addNewDesign );
    },

    // Function for getpoid
    setpoid(po_value, subcat_value) {
      this.selected_po_id = po_value;
      this.utility_type_arr = [];
      // this.getStyleList(this.selected_utility_id,po_value,subcat_value);
      this.getUtilityTypeList(subcat_value, this.selected_po_id);
    },
    setutilityid(utility_value, subcat_value, poid_value) {
      this.selected_utility_id = utility_value;

      if (poid_value == "" || poid_value == null || poid_value == 0) {
        var temp_po_value = this.po_typearr[0].po_id;
        // this.getStyleList(temp_po_value,utility_value,subcat_value);
        this.getDesignWithStyleCount(
          temp_po_value,
          utility_value,
          subcat_value
        );
      } else {
        // var temp_id= this.se
        // this.getStyleList(poid_value,utility_value,subcat_value);
        this.getDesignWithStyleCount(poid_value, utility_value, subcat_value);
      }
      // this.getStyleList(utility_value,poid_value,subcat_value);
    },

    newstylecancel: function () {
      this.artWorkUrl = "";
      this.artWorkId = '',
      this.selected_panton_type = "";
      this.story_name = "";
      this.sytleImageurl = "";
      this.stylePdfUrl = "";
      this.sampleImageurl = "";
      this.addNewStyle = !this.addNewStyle;
      this.style_type= '',
      this.fabrictype = []
    },

    removeImage: function (e) {
      this.remoteUrl = "";
    },
    //Code for Image Ends
    //code for buyer select
    checkAll: function () {
      this.isCheckAll = !this.isCheckAll;
      this.selectedbuyers = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.buyer_arr) {
          this.selectedbuyers.push(this.buyer_arr[key]);
          this.selectedbuyer_length = this.selectedbuyers.length;

        }
      }
    },
    updateCheckall: function () {
      if (this.selectedbuyers.length > 0) {
        if (this.selectedbuyers.length == this.buyer_arr.length) {
          this.isCheckAll = true;
          this.selectedbuyer_length = this.selectedbuyers.length;
        } else {
          this.isCheckAll = false;
          this.selectedbuyer_length = this.selectedbuyers.length;
        }
      } else {
        // alert("Please Select Atleast One Buyer");
        this.$fire({
          text: "Please Select Atleast One Buyer",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlay").style.display = "none";
      }
    },
    // printValues: function(){
    //   this.selectedbuyers = "";
    //   for (var key in this.selectedbuyers) {
    //      this.selectedbuyers += this.selectedbuyers[key]+", ";
    //   }
    // },
    //code for buyer select ends

    /****** Function to Get Collection Details ********/
    getcollectiondetails: function (value) {
      this.isBusy = true;
      const Obj = {
        collection_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getcollectiondetails`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.collection_details = this.result.returnvalue[0];
            this.collection_segment_id = this.collection_details.segment_id;
            this.selected_brandid = this.collection_details.brand_id;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.collection_details = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get Utility Type List********/
    getUtilityTypeList: function (value, po_id) {
      document.getElementById("overlay").style.display = "block";
      this.selected_subcat_id = value;
      this.isBusy = true;
      const Obj = {
        subcat_id: value,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getUtilityTypeList`, Obj)
        .then((response) => {
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            document.getElementById("overlay").style.display = "none";
            this.utility_type_arr = this.result.returnvalue;
            // this.style_list=[];
            // this.getStyleList(this.selected_po_id,this.selected_utility_id,value);

            this.selected_poid_tab = po_id;

            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.utility_type_arr = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get Utility Type List Ends********/

    /******Function To Get PO Type List********/
    getPoTypeList: function (value) {
      document.getElementById("overlay").style.display = "block";
      this.selected_sub_cat_id = value;
      this.isBusy = true;
      const Obj = {
        subcat_id: value,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.po_typearr = this.result.returnvalue;
            this.selected_po_id = this.po_typearr[0].po_id;

            this.selected_subcat_tab = value;

            this.getUtilityTypeList(value, this.selected_po_id);

            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
          document.getElementById("overlay").style.display = "none";
            this.po_typearr = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get PO Type List Ends********/

    /******Function To Get Buyer List********/
    getbuyerlist: function (value) {
      this.isBusy = true;
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      if (userInfo[0].user_type == "Brand_Designer") {
        this.user = userInfo[0].brand_manager;
      } else {
        this.user = userInfo[0].user_id;
      }
      const Obj = {
        brand_manager: this.user,
        brand_id: userInfo[0].brand_assign,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getbuyerlistagainstbrandmanager`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          this.buyer_response = this.result.returnmsg;
          if (this.result.returnmsg === "Successful") {
            // this.buyer_arr  = this.result.returnvalue;
            this.agentmaster = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            for (var i = 0; i < this.agentmaster.length; i++) {
              var vendoryagent2 = {
                id: this.agentmaster[i].buyer_id,
              };
              this.buyer_arr.push(this.agentmaster[i].buyer_id);
            }
            this.isBusy = !this.isBusy;
          } else {
            this.buyer_arr = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get Sub Category List********/
    //   getSubCategoryList: function(value) {

    //   axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`,{})
    //   .then(response => {
    //     //document.getElementById("overlay").style.display = "none";
    //     this.result = response.data

    //     if (this.result.returnmsg === 'Successful') {
    //       this.sub_cat_arr  = this.result.returnvalue;
    //       this.totalRows = this.result.returnvalue.length;

    //     }else {
    //      this.sub_cat_arr =[];
    //      this.totalRows=0;
    //     }

    //   })
    //   .catch(e => {
    //     this.errors.push(e)
    //   })
    // },

    /****** Function to Get ColectionList ********/
    getStyleList: function (poid, utilityid, subcatid) {
      document.getElementById("overlay").style.display = "block";
      // this.selected_subcat_id = subcatid;
      // this.selected_po_id =poid;
      // this.selected_utility_id= utilityid;

      this.isBusy = true;
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        const Obj = {
          // collection_id: this.$route.params.id,
          collection_id: this.$route.params.id,
          user_type: userInfo[0].user_type,
          user_id: userInfo[0].user_id,
          buyer_id: userInfo[0].user_id,
          po_id: poid,
          utility_id: utilityid,
          sub_catid: subcatid,
        };
        axios
          .post(`${CONSTANTS.API_URL}/getStyleDesignlist`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            // this.resuld_data_msg= this.result.returnmsg;
            if (this.result.returnmsg === "Successful") {
              this.result_data = this.result.returnvalue;
              // this.selected_style_name = this.style_list[0].design_title;
              this.totalRows = this.result.returnvalue.length;
              // this.selected_utility_id='';
              this.isBusy = !this.isBusy;
            } else {
              this.style_list = [];
              this.totalRows = 0;
              this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },

    // openaddNewDesign:function(){
    //   this.design_title='';
    //   this.sub_catid='';
    //   this.buyer_id='';
    //   this.po_id='';
    //   this.utility_id='';
    //   this.addNewDesign = !this.addNewDesign;
    // },

    openeditstyle: function (des_title, design_hit, des_id, des_buyer) {
      // console.log("des_title",des_title);

      // this.design_title=des_title;
      this.generated_design_id = des_id;
      this.selectedbuyers = des_buyer;
      this.editstyleModal = true;
      setTimeout(function () {
        document.getElementById("edit_design_title").value = des_title;
        document.getElementById("edit_design_hit").value = design_hit;
      }, 1000);
    },
    
    validateForm(value) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createdesignForm(value);
        }
      });
    },

    validateForm2(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.editstyledetails(scope);
        }
      });
    },

    validateForm4(scope) {
      console.log("this.sytleImageurllllllllllll---", this.sytleImageurl)
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if(this.sytleImageurl && (this.sytleImageurl != '' || this.sytleImageurl != null || this.sytleImageurl != undefined)){
            this.calculateTotalQuantity();
          }
          else{
            this.$fire({
                  text: "Please upload style image",
                  type: "error",
                  timer: 30000,
                });
          }
         
        }
      });
    },

    checkdraftvalue: function (value) {
      this.artWorkUrl = "";
      this.draft_flag = value;
    },

    /****** Function to Add Collection ********/
    createdesignForm(design_value) {
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var d_title = "";
      d_title = document.getElementById("selcted_design_title").value;
      let d_hit = document.getElementById("selcted_design_hit").value;
      var assign_buyer_id = [];
      assign_buyer_id.push(this.selectedbuyers);
      if (this.user_type == "Buyer") {
        this.buyer_id = assign_buyer_id;
        this.selected_buyer_id = this.buyer_id;
      }
      if (this.selectedbuyers.length != 0) {
        this.$validator.validateAll().then((result) => {
          const designObj = {
            collection_id: this.$route.params.id,
            design_title: d_title,
            design_hit: d_hit,
            brand_id: this.selected_brandid,
            sub_catid: this.selected_subcat_id,
            buyer_id: this.selectedbuyers,
            created_by: userInfo[0].email_id,
            po_id: this.selected_po_id,
            utility_id: this.selected_utility_id,
            designer_id: userInfo[0].user_id,
          };

          axios
            .post(`${CONSTANTS.API_URL}/addnewdesign`, designObj)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                // alert("New Style Added Successfully.");
                this.$fire({
                  text: "New Style Added Successfully.",
                  type: "success",
                  timer: 30000,
                });
                this.addNewDesign = !this.addNewDesign;
                // this.showstyledetails(this.generated_design_id);
                this.getDesignWithStyleCount(
                  this.selected_po_id,
                  this.selected_utility_id,
                  this.selected_subcat_id,
                  
                );
                this.selectedbuyers = [];
                  this.isCheckAll = false;
                // this.getStyleList(this.selected_po_id,this.selected_utility_id,this.selected_subcat_id);
                this.getcollectiondetails();
              } else {
                if (response.data.returnmsg === "unsuccessful") {
                  // alert(response.data.returnvalue);
                  this.$fire({
                    text: response.data.returnvalue,
                    type: "error",
                    timer: 30000,
                  });
                  this.showAlert = true;
                  this.selectedbuyers = [];
                }
              }
            });
        });
      } else {
        // alert("Please Select Atleast One Buyer");
        this.$fire({
          text: "Please Select Atleast One Buyer",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlay").style.display = "none";
      }
    },

    editstyledetails(scope) {
      const uniqueArray = [...new Set(this.selectedbuyers)];
      document.getElementById("overlay").style.display = "block";
      var edit_title = "";
      edit_title = document.getElementById("edit_design_title").value;
      let edit_design_hit = document.getElementById("edit_design_hit").value;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var assign_buyer_id = [];
      assign_buyer_id.push(this.buyer_id);
      if (this.selectedbuyers != 0) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            const designObj = {
              collection_id: this.$route.params.id,
              design_title: edit_title,
              design_hit: edit_design_hit,
              buyer_id: uniqueArray,
              updated_by: userInfo[0].email_id,
              design_id: this.generated_design_id,
            };
            if (edit_title !== "") {
              axios
                .post(`${CONSTANTS.API_URL}/editstyledetails`, designObj)
                .then((response) => {
                  document.getElementById("overlay").style.display = "none";
                  if (response.data.returnmsg == "Successful") {
                    // alert("Style Updated Successfully.");
                    this.$fire({
                      text: "Style Updated Successfully.",
                      type: "success",
                      timer: 30000,
                    });
                    this.editstyleModal = !this.editstyleModal;
                    this.getDesignWithStyleCount(
                      this.selected_po_id,
                      this.selected_utility_id,
                      this.selected_subcat_id
                    );
                    // this.showstyledetails(this.generated_design_id);
                    // this.getStyleList(this.selected_po_id,this.selected_utility_id,this.selected_subcat_id);
                    // this.getcollectiondetails();
                  } else {
                    if (response.data.returnmsg === "unsuccessful") {
                      // alert(response.data.returnvalue);
                      this.$fire({
                        text: response.data.returnvalue,
                        type: "error",
                        timer: 30000,
                      });
                      this.showAlert = true;
                    }
                  }
                });
            }
          }
        });
      } else {
        // alert("Please Select Atleast One Buyer");
        this.$fire({
          text: "Please Select Atleast One Buyer",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlay").style.display = "none";
      }
    },

    adddraftStyleDetails(
      design_id,
      design_title,
      story_title,
      s_color,
      s_sizeset,
      s_description,
      s_image,
      index,
      style_id,
      is_draft,
      image
    ) {
      this.selected_style_name = design_title;
      this.selected_story_name = story_title;
      this.color = s_color;
      this.generated_design_id = design_id;
      this.selected_sizeset = s_sizeset;
      this.style_description = s_description;
      this.selected_style_id = style_id;
      this.check_draft_value = is_draft;
      this.selected_style_image = image;
      this.selected_panton_type = "";
      // this.size_set=[];
      this.addNewStyle = true;
    },
    // design_id, design_title, buyer_id, index
    addStyleDetails(design_id, design_title,sub_cat) {
      // if(this.style_list[index].style_list[0]=='' || this.style_list[index].style_list[0]== undefined ){
      this.selected_style_name = design_title;
      this.selected_story_name = "";
      this.sizeset = [];
      this.style_description = "";
      this.color = "";
      this.selected_color_family = "";
      this.selected_pantone_no = "";
      this.selected_panton_type = "";
      this.selected_color = "";
      this.selected_sizeset = "";
      this.selected_color_family = "";
      this.selected_pantone_no = "";
      this.selected_panton_type = "";
      this.selected_sizeset = null;
      this.generated_design_id = design_id;
      this.selected_panton_type = "";
      this.range_selectedtoage = "";
      this.range_selected_month = "";
      this.range_selectedfromage = "";
      this.invoice_products = [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ];
      this.addNewStyle = !this.addNewStyle;
      this.sub_cat = sub_cat;
      

      // this.addNewStyle =true;
      // this.generated_design_id=design_id;
      //}
    },

    /****** Function to add design image ********/
      AddDesignimage(event) {
      // alert("inn");
      this.progress1 = 0;
      document.getElementById("progress_bar1").style.display = "block";
      let file = event.target.files[0];
      this.uploadedfile = file;
      this.selectFiletype = event.target.files[0].type;
      // this.styleImage();
      const regex = /[!@#$%^&*(),?"';:{}|<>\s]/g;
      let filename = file.name;
      this.container.filename = filename.replace(regex, "_");
      this.container.file = file;
      document.getElementById("overlay").style.display = "none";
      this.handleUpload();
    
    },
    
    styleImage: function () {
      this.progress1 = 0;
      document.getElementById("progress_bar1").style.display = "block";
      if (this.uploadedfile != undefined) {
        document.getElementById("modal_overlay").style.display = "block";
        // return false;
        this.uploadedfile = event.target.files[0];
        let data = new FormData();

        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        data.append("file", this.uploadedfile);
        axios
          .post(`${CONSTANTS.API_URL}/pdfToImage`, data, {
            header: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function (progressEvent) {
              this.progress1 = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }.bind(this),
          })
          .then((response) => {
            console.log("HHHHHH", response);

            document.getElementById("modal_overlay").style.display = "none";
            if (response.data.result == "success") {
              this.sytleImageurl = response.data.image_url;
              this.stylePdfUrl = response.data.pdf_url;
              console.log("TTTTT", this.sytleImageurl);
              document.getElementById("progress_bar1").style.display = "block";
              this.progress1 = 100;
            } else {
              this.sytleImageurl = "";
              this.stylePdfUrl = "";
            }
          });
      }
    },
    /****** Function to add design image ends ********/

    /****** Function to upload techpack ********/
    showModal() {
      // Clear previous file selection when opening modal
      this.file = null;
      this.isDragging = false;
      this.progress1 = 0;
      
      // Open modal first
      this.modalVisible = true;
      
      // Use $nextTick to ensure DOM is updated before accessing elements
      this.$nextTick(() => {
        const progressBar = document.getElementById("progress_bar1");
        if (progressBar) {
          progressBar.style.display = "none";
        }
        
        // Reset the file input if it exists
        if (this.$refs.fileInput) {
          this.$refs.fileInput.reset();
        }
      });
    }, 
    /****** Function to disable upload file model ********/
    cancelUploadFilemodal() {
      this.modalVisible = !this.modalVisible;
      this.isDragging = false;
      this.file = null;
    },

    /****** Drag and Drop Functions ********/
    handleDragEnter(e) {
      this.isDragging = true;
    },
    
    handleDragOver(e) {
      this.isDragging = true;
    },
    
    handleDragLeave(e) {
      // Only set isDragging to false if we're leaving the drop zone
      if (e.target.classList.contains('drag-drop-zone')) {
        this.isDragging = false;
      }
    },
    
    handleDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      
      if (files.length > 0) {
        const file = files[0];
        const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
        
        // Validate file type
        if (!allowedTypes.includes(file.type)) {
          alert('Please upload only PDF, PNG, JPEG, or JPG files.');
          return;
        }
        
        // Set the file
        this.file = file;
        
        // Create a synthetic event object to pass to AddDesignimage
        const syntheticEvent = {
          target: {
            files: [file]
          }
        };
        
        this.AddDesignimage(syntheticEvent);
      }
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    /****** Drag and Drop Functions End ********/
    
    /****** Function to create techpack ********/
    /*
    Function: createTechPack()
    Description: Create a tech pack when button is clicked from the data filled and generate pdf automatically.
    Created Date : 09/04/2024
    Created By: Adarsh S. Bhutada
    */
    createTechPack() {
      if (
        this.style_type === '' ||
        this.selected_story_name === '' ||
        this.style_description === '' ||
        this.material === '' ||
        this.top_fabric === '' ||
        this.bottom_fabric === '' ||
        this.fabrictype === '' ||
        this.selected_panton_type === '' ||
        this.pack_of === ''
      ) {
        this.$fire({
          text: "All fields are Mandatory...!",
          type: "warning",
          timer: 30000,
        });
      }
      else {

        document.getElementById("overlay").style.display = "block";
        this.selected_draft_value = this.draft_flag;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var user_id = userInfo[0].user_id;
        this.progress = 0;
        var size_details = this.invoice_products;

        let data = new FormData();

        var main_arr = [];
        main_arr.push(this.invoice_products[0]);

        if (this.colorcheck != "OTHERS") {
          this.temp_selected_color_family = this.selected_color_family;

          this.temp_selected_pantone_no = this.selected_pantone_no.key;

          this.temp_selected_panton_type = this.selected_panton_type;
          this.selected_color = this.selected_final_color;
        }   else {
            const hexRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

            if (!hexRegex.test(this.color)) {
              this.$fire({
                text: "Please enter a valid hex color code. e.g #111 or #000000 or #1C318C",
                type: "error",
                timer: 30000,
              });
              document.getElementById("overlay").style.display = "none";
              return;   // <<< BLOCK EVERYTHING, STOP FUNCTION
            }

            this.selected_color_family = "";
            this.selected_pantone_no = "";
            this.selected_panton_type = "";
            this.temp_selected_panton_type = this.other_value;
            this.selected_color = this.color;
          }
        // alert(this.temp_selected_panton_type);

        // return false;

        // if(check_val==temp_from_age.length){
        if (
          this.check_draft_value == 0 &&
          (this.selected_draft_value == 0 || this.selected_draft_value == 1)
        ) {
        if (
          !this.selected_story_name ||
          typeof this.selected_story_name !== "string" ||
          this.selected_story_name.trim() === ""
        ) {
          this.$fire({
            text: "Story Name cannot be empty or only spaces.",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlay").style.display = "none";
          return;
        }

          if (
          !this.style_description ||
          typeof this.style_description !== "string" ||
          this.style_description.trim() === ""
        ) {
          this.$fire({
            text: "style description cannot be empty or only spaces.",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlay").style.display = "none";
          return;
        }

        // 
        
        
          if (this.sampleImageurl != undefined) {
            
            data.append("style_image", this.sytleImageurl);
            console.log("File", this.sytleImageurl);
            data.append("style_pdf", this.stylePdfUrl);
            data.append("sample_image", this.sampleImageurl);
            console.log("File1", this.sampleImageurl);
            data.append("style_name", this.selected_style_name);
            data.append("story_name", this.selected_story_name);

            data.append("style_code", "");
            data.append("design_id", this.generated_design_id);
            data.append("user_id", user_id);
            data.append("brand_id", this.selected_brandid);
            data.append("style_description", this.style_description);
            data.append("sub_catid", this.selected_subcat_id);
            data.append("segment_id", this.collection_segment_id);
            data.append("user_type", userInfo[0].user_type);
            data.append("po_id", this.selected_po_id);
            data.append("utility_id", this.selected_utility_id);
            data.append("color_family", this.temp_selected_color_family);
            data.append("pantone_no", this.selected_pantone_no.key);
            data.append("panton_type", this.temp_selected_panton_type);
            data.append("color", this.selected_color);
            data.append("size_details", JSON.stringify(main_arr));
            data.append("no_of_sizeset", 0);
            data.append("created_by", userInfo[0].user_id);
            data.append("draft_value", this.selected_draft_value);
            data.append("style_id", this.selected_style_id);
            data.append("brand_manager", userInfo[0].brand_manager);
            data.append("artwork_id", this.artWorkId);
            data.append("style_type", this.style_type);
            data.append("fabric_type", this.fabrictype);
            data.append("solematerial", this.bottom_fabric);
            data.append("materialinfoupperfabric", this.top_fabric);
            data.append('material', this.material);
            data.append('pack_of', this.pack_of);
            data.append('is_epp', this.is_epp);
            data.append('style_comment', this.style_comment)
          }
          else {
            data.append("style_image", this.sytleImageurl);
            console.log("File", this.sytleImageurl);
            data.append("style_pdf", this.stylePdfUrl);
            data.append("sample_image", "");
            console.log("File1", this.sampleImageurl);
            data.append("style_name", this.selected_style_name);
            data.append("story_name", this.selected_story_name);

            data.append("style_code", "");
            data.append("design_id", this.generated_design_id);
            data.append("user_id", user_id);
            data.append("brand_id", this.selected_brandid);
            data.append("style_description", this.style_description);
            data.append("sub_catid", this.selected_subcat_id);
            data.append("segment_id", this.collection_segment_id);
            data.append("user_type", userInfo[0].user_type);
            data.append("po_id", this.selected_po_id);
            data.append("utility_id", this.selected_utility_id);
            data.append("color_family", this.temp_selected_color_family);
            data.append("pantone_no", this.selected_pantone_no.key);
            data.append("panton_type", this.temp_selected_panton_type);
            data.append("color", this.selected_color);
            data.append("size_details", JSON.stringify(main_arr));
            data.append("no_of_sizeset", 0);
            data.append("created_by", userInfo[0].user_id);
            data.append("draft_value", this.selected_draft_value);
            data.append("style_id", this.selected_style_id);
            data.append("brand_manager", userInfo[0].brand_manager);
            data.append("artwork_id", this.artWorkId);
            data.append("style_type", this.style_type);
            data.append("fabric_type", this.fabrictype);
            data.append("solematerial", this.bottom_fabric);
            data.append("materialinfoupperfabric", this.top_fabric);
            data.append('material', this.material);
            data.append('pack_of', this.pack_of);
            data.append('is_epp', this.is_epp);
            data.append('style_comment', this.style_comment)
          }
          // for ( var key in this.invoice_products[0] ) {
          //     data.append('size_details', this.invoice_products[0]);
          // }
          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%", data);
          // return false;
          axios
            .post(`${CONSTANTS.API_URL}/addnewstyles`, data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                console.log("returnvaluereturnvaluereturnvalue---------------->", response.data.returnvalue)
                console.log("style_code---------------->", response.data.style_code)
                this.style_image = response.data.url;
                this.style_code = response.data.style_code;
                // alert("New Color For Style Added Successfully.");
                // this.$fire({
                //   text: "New Color For Style Added Successfully.",
                //   type: "success",
                //   timer: 30000,
                // });
                var userData = localStorage.getItem("userData");
                var userInfo = JSON.parse(userData);
                var fullName = userInfo[0].full_name;

                localStorage.setItem('formData', JSON.stringify({
                    style_type: this.style_type,
                    story_name: this.selected_story_name,
                    style_description: this.style_description,
                    style_code: this.style_code,
                    designer_name: fullName,
                }));
                window.location.href = '/create_artwork';
                document.getElementById("progress_bar").style.display = "none";

                 this.addNewStyle = !this.addNewStyle;
                 this.sizeset = [];
                 this.artWorkUrl = "";
                 this.artWorkId = '',
                 this.style_description = "";
                 this.color = "";
                 this.selected_color_family = "";
                 this.selected_pantone_no = "";
                 this.selected_panton_type = "";
                 this.selected_color = "";
                 this.selected_sizeset = "";
                 this.selected_color_family = "";
                 this.selected_panton_type = "";
                 this.style_type = '',
                 this.fabrictype = '',
                 this.invoice_products = [
                     {
                       unit: [],
                       selectedfromage: [],
                       selectedtoage: [],
                       quantity: [],
                       factorysize: [],
                       },
                   ];
                 this.selected_month = [];
                 this.selected_age = 0;
                 this.selectedfromage = [];
                 this.selectedtoage = [];
                 this.quantity = [];
                 this.factorysize = [];
                 this.bottom_fabric = ''
                 this.top_fabric = ''
                 this.material = ''
                 this.is_epp = ''
                // this.pack_of = ''

                // this.showstyledetails(this.generated_design_id);
                // this.getStyleList(this.selected_po_id,this.selected_utility_id,this.selected_subcat_id);
              } else {
                if (response.data.returnmsg === "unsuccessful") {
                  // alert(response.data.returnvalue);
                  this.$fire({
                    text: response.data.returnvalue,
                    type: "error",
                    timer: 30000,
                  });
                  this.sytleImageurl = "";
                  localStorage.setItem('formData', JSON.stringify({}));
                  this.showAlert = true;

                }
              }
            });
        } else if (this.check_draft_value == 1 || this.selected_draft_value ==1) {
          this.flag = 0;
          let data = new FormData();
          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          if (this.sytleImageurl != undefined) {
            data.append("style_image", this.sytleImageurl);
            console.log("File", this.sytleImageurl);
            data.append("style_pdf", this.stylePdfUrl);
            data.append("sample_image", this.sampleImageurl);
            console.log("File1", this.sampleImageurl);
            data.append("style_id", this.selected_style_id);
            data.append("style_name", this.selected_style_name);
            data.append("story_name", this.selected_story_name);
            data.append("updated_by", userInfo[0].user_id);
            data.append("color_family", this.selected_color_family);
            data.append("pantone_no", this.selected_pantone_no.key);
            data.append("panton_type", this.selected_panton_type);
            data.append("color", this.selected_color);
            data.append("no_of_sizeset", 0);
            data.append("style_description", this.style_description);
            data.append("brand_id", this.selected_brandid);
            data.append("flag", this.flag);
            data.append("is_draft", this.selected_draft_value);
          } else {
            data.append("file", "");
            data.append("file1", "");
            data.append("style_id", this.selected_style_id);
            data.append("style_name", this.selected_style_name);
            data.append("story_name", this.selected_story_name);
            data.append("updated_by", userInfo[0].user_id);
            data.append("color_family", this.selected_color_family);
            data.append("pantone_no", this.selected_pantone_no.key);
            data.append("panton_type", this.selected_panton_type);
            data.append("color", this.selected_color);
            data.append("no_of_sizeset", 0);
            data.append("style_description", this.style_description);
            data.append("brand_id", this.selected_brandid);
            data.append("flag", this.flag);
            data.append("is_draft", this.selected_draft_value);
          }
          axios
            .post(`${CONSTANTS.API_URL}/updatestyle`, data, config)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              this.result = response.data;
              if (this.result.returnmsg === "Successful") {
                // alert("Updated Successfully", "success");
                this.$fire({
                  text: "Updated Successfully",
                  type: "success",
                  timer: 30000,
                });
                this.addNewStyle = !this.addNewStyle;
                this.selected_panton_type = "";
                this.getStyleList(
                  this.selected_po_id,
                  this.selected_utility_id,
                  this.selected_subcat_id
                );
                this.sizeset = [];
                this.style_description = "";
                this.color = "";
                this.selected_color_family = "";
                this.selected_pantone_no = "";
                this.selected_panton_type = "";
                this.selected_color = "";
                this.selected_sizeset = "";
                this.selected_color_family = "";
                this.selected_pantone_no = "";
                this.selected_panton_type = "";
                this.bottom_fabric = ''
                this.top_fabric = ''
              } else {
                // alert(this.result.returnvalue);
                this.$fire({
                  text: this.result.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.sytleImageurl = '';
              }
            })

            .catch((e) => {
              this.errors.push(e);
            });
          //Adeed code ends
          // }
        }
      }  
        

    // For store data in userdata and redirect to create artwork page 
    // var userData = localStorage.getItem("userData");
    // var userInfo = JSON.parse(userData);
    // var fullName = userInfo[0].full_name;

    // localStorage.setItem('formData', JSON.stringify({
    //     style_type: this.style_type,
    //     story_name: this.selected_story_name,
    //     style_description: this.style_description,
    //     style_code: this.style_code
    // }));
    // window.location.href = '/create_artwork';
        // material: this.material,
        // materialinfoupperfabric:this.top_fabric,
        // solematerial:this.bottom_fabric,
        // fabric_type: this.fabrictype,
        // panton_type: this.selected_panton_type,
        // panton_color: this.selected_panton_color,
        // pantone_no: this.selected_pantone_no.key,
        // selected_color:this.selected_color, 
        // pack_of: this.pack_of,
        // designer_name: fullName,
        // design_id:this.generated_design_id,
        // user_id:userInfo[0].user_id,
        // brand_id:this.selected_brandid,
        // sub_catid:this.selected_subcat_id,
        // segment_id:this.collection_segment_id,
        // po_id: this.selected_po_id,
        // utility_id: this.selected_utility_id,
        // color_family: this.temp_selected_color_family,
        // created_by:userInfo[0].user_id,
        // draft_value:this.selected_draft_value,
        // style_id: this.selected_style_id,
        // brand_manager:userInfo[0].brand_manager,
        // artwork_id:this.artWorkId,
        // style_pdf: this.stylePdfUrl,
        // user_type: userInfo[0].user_type,
        // size_details: this.invoice_products[0],
        // no_of_sizeset: this.no_of_sizeset,
        // style_comment: this.style_comment, 
        // selectedBrandId: this.selectedBrandId,
        // style_code: 
        // design_id: ,
        // user_id: ,
        // brand_id: ,
        // sub_catid: ,
        // segment_id:,
        // user_type: ,
        // po_id: ,
        // utility_id: ,
        // color_family: this.selected_color_family, 
        // pantone_no: this.selected_pantone_no.key,
    
        // color: ,
        // size_details: ,
        // no_of_sizeset: ,
        // created_by: ,
        // draft_value: ,
        // style_id: ,
        // brand_manager: ,
        // artwork_id:,
        // solematerial: ,
        // materialinfoupperfabric: ,
        // material:this.material ,
        // pack_of: ,
        // is_epp: ,
        // style_comment: ,
   

    // Redirect to tech pack creation page
      
},


    /****** Function to add sample image ********/
    AddSampleimage: function (event) {
      this.sampleFile = event.target.files[0];
      // console.log("Sample File",this.sampleFile);
      this.sampleImage();
    },

    sampleImage: function () {
      if (this.sampleFile != undefined) {
        document.getElementById("modal_overlay").style.display = "block";
        console.log("SSSSSSSSSS", this.sampleFile);
        // return false;
        // this.uploadedfile = event.target.files[0];
        let data = new FormData();
        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        data.append("file", this.sampleFile);
        axios
          .post(`${CONSTANTS.API_URL}/uploadfiletos3`, data, {
            header: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log("HHHHHH", response);
            document.getElementById("modal_overlay").style.display = "none";
            // document.getElementById("overlay").style.display = "none";
            if (response.data.result == "success") {
              this.sampleImageurl = response.data.image_url;
              console.log("SFSFSFS", this.sampleImageurl);

            this.$fire({
                text: "File Uploaded Successfully.",
                type: "success",
                timer: 30000,
              });

              this.modalVisible = false;

            } else {
               this.$fire({
                text: "Error in file uploading, Please try again",
                type: "error",
                timer: 30000,
              });

              this.modalVisible = false;
              this.sampleImageurl = "";
            }
          });
      }
    },
    /****** Function to add sample image end ********/

    


    /****** Function to Add Design ********/
    AddDesignfunction() {
        console.log("this.sytleImageurl", this.sytleImageurl)

      // if(this.sytleImageurl == '' || this.sytleImageurl == null)
        
      //   {
      //        this.$fire({
      //           text: "Please Upload Techpack File",
      //           type: "error",
      //           timer: 30000,
      //           });
      //   } 

      // else {    

      document.getElementById("progress_bar").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      this.selected_draft_value = this.draft_flag;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var user_id = userInfo[0].user_id;
      this.progress = 0;
      var size_details = this.invoice_products;

      let data = new FormData();

      var main_arr = [];
      main_arr.push(this.invoice_products[0]);

      if (this.colorcheck != "OTHERS") {
        this.temp_selected_color_family = this.selected_color_family;

        this.temp_selected_pantone_no = this.selected_pantone_no.key;

        this.temp_selected_panton_type = this.selected_panton_type;
        this.selected_color = this.selected_final_color;
      }  else {
            const hexRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

            if (!hexRegex.test(this.color)) {
              this.$fire({
                text: "Please enter a valid hex color code. e.g #111 or #000000 or #1C318C",
                type: "error",
                timer: 30000,
              });
              document.getElementById("overlay").style.display = "none";
              return;   // <<< BLOCK EVERYTHING, STOP FUNCTION
            }

            this.selected_color_family = "";
            this.selected_pantone_no = "";
            this.selected_panton_type = "";
            this.temp_selected_panton_type = this.other_value;
            this.selected_color = this.color;
          }
      // alert(this.temp_selected_panton_type);

      // return false;

      // if(check_val==temp_from_age.length){
      if (
        this.check_draft_value == 0 &&
        (this.selected_draft_value == 0 || this.selected_draft_value == 1)
      )
      {
         if (
          !this.selected_story_name ||
          typeof this.selected_story_name !== "string" ||
          this.selected_story_name.trim() === ""
        ) {
          this.$fire({
            text: "Story Name cannot be empty or only spaces.",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlay").style.display = "none";
          return;
        } 

        if (
          !this.style_description ||
          typeof this.style_description !== "string" ||
          this.style_description.trim() === ""
        ) {
          this.$fire({
            text: "style description cannot be empty or only spaces.",
            type: "warning",
            timer: 30000,
          });
          document.getElementById("overlay").style.display = "none";
          return;
        }


        if (this.sampleImageurl != undefined) {
          data.append("style_image", this.sytleImageurl);
          data.append("style_pdf", this.stylePdfUrl);
          data.append("sample_image", this.sampleImageurl);
          data.append("style_name", this.selected_style_name);
          data.append("story_name", this.selected_story_name);


          data.append("style_code", "");
          data.append("design_id", this.generated_design_id);
          data.append("user_id", user_id);
          data.append("brand_id", this.selected_brandid);
          data.append("style_description", this.style_description);
          data.append("sub_catid", this.selected_subcat_id);
          data.append("segment_id", this.collection_segment_id);
          data.append("user_type", userInfo[0].user_type);
          data.append("po_id", this.selected_po_id);
          data.append("utility_id", this.selected_utility_id);
          data.append("color_family", this.temp_selected_color_family);
          data.append("pantone_no", this.selected_pantone_no.key);
          data.append("panton_type", this.temp_selected_panton_type);
          data.append("color", this.selected_color);
          data.append("size_details", JSON.stringify(main_arr));
          data.append("no_of_sizeset", 0);
          data.append("created_by", userInfo[0].user_id);
          data.append("draft_value", this.selected_draft_value);
          data.append("style_id", this.selected_style_id);
          data.append("brand_manager", userInfo[0].brand_manager);
          data.append("artwork_id", this.artWorkId);
          data.append("style_type", this.style_type);
          data.append("fabric_type", this.fabrictype);
          data.append("solematerial", this.bottom_fabric);
          data.append("materialinfoupperfabric", this.top_fabric);
          data.append('material',this.material);
          data.append('pack_of',this.pack_of);
          data.append('is_epp',this.is_epp);
          data.append('style_comment', this.style_comment)
          data.append('upper_material',this.upper_material)
          data.append('inner_lining',this.inner_lining)
          data.append('sole',this.sole)
          data.append('surface_ornamentation',this.surface_ornamentation)
          data.append('highlight',this.highlight)
          data.append('Fastening_type',this.Fastening_type) 
        } else {
          data.append("style_image", this.sytleImageurl);
          data.append("style_pdf", this.stylePdfUrl);
          data.append("sample_image", "");
          data.append("style_name", this.selected_style_name);
          data.append("story_name", this.selected_story_name);

          data.append("style_code", "");
          data.append("design_id", this.generated_design_id);
          data.append("user_id", user_id);
          data.append("brand_id", this.selected_brandid);
          data.append("style_description", this.style_description);
          data.append("sub_catid", this.selected_subcat_id);
          data.append("segment_id", this.collection_segment_id);
          data.append("user_type", userInfo[0].user_type);
          data.append("po_id", this.selected_po_id);
          data.append("utility_id", this.selected_utility_id);
          data.append("color_family", this.temp_selected_color_family);
          data.append("pantone_no", this.selected_pantone_no.key);
          data.append("panton_type", this.temp_selected_panton_type);
          data.append("color", this.selected_color);
          data.append("size_details", JSON.stringify(main_arr));
          data.append("no_of_sizeset", 0);
          data.append("created_by", userInfo[0].user_id);
          data.append("draft_value", this.selected_draft_value);
          data.append("style_id", this.selected_style_id);
          data.append("brand_manager", userInfo[0].brand_manager);
          data.append("artwork_id", this.artWorkId);
          data.append("style_type", this.style_type);
          data.append("fabric_type", this.fabrictype);
          data.append("solematerial", this.bottom_fabric);
          data.append("materialinfoupperfabric", this.top_fabric);
          data.append('material',this.material);
          data.append('pack_of',this.pack_of);
          data.append('is_epp',this.is_epp);
          data.append('style_comment', this.style_comment)
          data.append('upper_material',this.upper_material)
          data.append('inner_lining',this.inner_lining)
          data.append('sole',this.sole)
          data.append('surface_ornamentation',this.surface_ornamentation)
          data.append('highlight',this.highlight)
          data.append('Fastening_type',this.Fastening_type) 
        }
        // for ( var key in this.invoice_products[0] ) {
        //     data.append('size_details', this.invoice_products[0]);
        // }
        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%", data);
        // return false;
        axios
          .post(`${CONSTANTS.API_URL}/addnewstyles`, data, {
            header: {
              "Content-Type": "multipart/form-data",
            },
            // onUploadProgress: function (progressEvent) {
            //   this.progress = Math.round(
            //     (progressEvent.loaded * 100) / progressEvent.total
            //   );
            // }.bind(this),
          })
          .then((response) => {
            // this.progress = Math.round(
            //   (100 * response.loaded) / response.total
            // );
            // document.getElementById("overlay").style.display = "none";
            if (response.data.returnmsg == "Successful") {
               document.getElementById("design_" + this.generated_design_id).innerHTML = "";
              this.addNewStyle = false;
              this.$fire({
                      text: "Style addedd successfully",
                      type: "success",
                      timer: 60000
                    });

              if (this.selected_draft_value == 0) {
                let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
                var fullName = userInfo[0].full_name;

                const emailObj = {
                  style_code: response.data.style_code,
                  brand_name: brandName,
                  designer_name: fullName,
                  user_id: userInfo[0].user_id,
                }

                axios.post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj).then((response) => {
                  if (response.data.returnmsg === 'Successful') {

                    this.$fire({
                      text: "email sent successfully for approval..!",
                      type: "success",
                      timer: 60000
                    });
                  }
                  else {
                    this.$fire({
                      text: "something went wrong in email sending!",
                      type: "warning",
                      timer: 30000
                    });
                  }
                })

                this.style_image = response.data.url;
                // alert("New Color For Style Added Successfully.");
                this.$fire({
                  text: "New Color For Style Added Successfully.",
                  type: "success",
                  timer: 30000,
                });
              }
              document.getElementById("progress_bar").style.display = "none";

              this.addNewStyle = !this.addNewStyle;
              this.sizeset = [];
              this.artWorkUrl = "";
              this.artWorkId = '',
              this.style_description = "";
              this.color = "";
              this.selected_color_family = "";
              this.selected_pantone_no = "";
              this.selected_panton_type = "";
              this.selected_color = "";
              this.selected_sizeset = "";
              this.selected_color_family = "";
              this.selected_panton_type = "";
              this.style_type = '',
              this.fabrictype = '',
              this.invoice_products = [
                {
                  unit: [],
                  selectedfromage: [],
                  selectedtoage: [],
                  quantity: [],
                  factorysize: [],
                },
              ];
              this.selected_month = [];
              this.selected_age = 0;
              this.selectedfromage = [];
              this.selectedtoage = [];
              this.quantity = [];
              this.factorysize = [];
              this.bottom_fabric = ''
              this.top_fabric = ''
              this.material = ''
              this.is_epp = ''
              this.pack_of = ''
              this.style_comment =''
              this.upper_material = ''
              this.inner_lining = ''
              this.sole = ''
              this.surface_ornamentation = ''
              this.highlight = ''
              this.Fastening_type = ''
              this.epp = ''
              this.showstyledetails(this.generated_design_id);
              this.addNewStyle = false;
            } else {
              if (response.data.returnmsg === "unsuccessful") {
                // alert(response.data.returnvalue);
                this.$fire({
                  text: response.data.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.showAlert = true;
                this.addNewStyle = false;
              }
            }
          });
      }

      else if (this.check_draft_value == 1) {
        this.flag = 0;
        let data = new FormData();
        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        if (this.sytleImageurl != undefined) {
          data.append("style_image", this.sytleImageurl);
          console.log("File", this.sytleImageurl);
          data.append("style_pdf", this.stylePdfUrl);
          data.append("sample_image", this.sampleImageurl);
          console.log("File1", this.sampleImageurl);
          data.append("style_id", this.selected_style_id);
          data.append("style_name", this.selected_style_name);
          data.append("story_name", this.selected_story_name);
          data.append("updated_by", userInfo[0].user_id);
          data.append("color_family", this.selected_color_family);
          data.append("pantone_no", this.selected_pantone_no.key);
          data.append("panton_type", this.selected_panton_type);
          data.append("color", this.selected_color);
          data.append("no_of_sizeset", 0);
          data.append("style_description", this.style_description);
          data.append("brand_id", this.selected_brandid);
          data.append("flag", this.flag);
          data.append("is_draft", this.selected_draft_value);
        } else {
          data.append("file", "");
          data.append("file1", "");
          data.append("style_id", this.selected_style_id);
          data.append("style_name", this.selected_style_name);
          data.append("story_name", this.selected_story_name);
          data.append("updated_by", userInfo[0].user_id);
          data.append("color_family", this.selected_color_family);
          data.append("pantone_no", this.selected_pantone_no.key);
          data.append("panton_type", this.selected_panton_type);
          data.append("color", this.selected_color);
          data.append("no_of_sizeset", 0);
          data.append("style_description", this.style_description);
          data.append("brand_id", this.selected_brandid);
          data.append("flag", this.flag);
          data.append("is_draft", this.selected_draft_value);
        }
        axios
          .post(`${CONSTANTS.API_URL}/updatestyle`, data, config)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // alert("Updated Successfully", "success");
              this.$fire({
                text: "Updated Successfully",
                type: "success",
                timer: 30000,
              });
              this.addNewStyle = !this.addNewStyle;
              this.selected_panton_type = "";
              this.getStyleList(
                this.selected_po_id,
                this.selected_utility_id,
                this.selected_subcat_id
              );
              this.sizeset = [];
              this.style_description = "";
              this.color = "";
              this.selected_color_family = "";
              this.selected_pantone_no = "";
              this.selected_panton_type = "";
              this.selected_color = "";
              this.selected_sizeset = "";
              this.selected_color_family = "";
              this.selected_pantone_no = "";
              this.selected_panton_type = "";
              this.bottom_fabric = ''
              this.top_fabric = ''
            }
            else {
              // alert(this.result.returnvalue);
              this.$fire({
                text: this.result.returnvalue,
                type: "error",
                timer: 30000,
              });
              this.addNewStyle = false;
            }
          })

          .catch((e) => {
            this.errors.push(e);
          });
        //Adeed code ends
        // }
      }
    //}

    },

    seeOriginalImage: function () {
      this.imageGalleryModal = true;
    },
    seeOriginalImageedited: function (url) {
      this.origin_image_name = url;
      this.originalImageModal = true;
    },
    cancelmodalimage: function () {
       this.artwork_id ="",
       this.artWorkId ="",
      this.artWorkUrl="",
      this.imageGalleryModal = false;
    },
    cancelmodalimageedited: function () {
      this.artwork_id ="",
      this.artWorkUrl="",
       this.artWorkId ="",
      this.originalImageModal = false;
    },
    SelectImage: function (id, url) {
      this.artWorkId = id;
      this.artWorkUrl = url;
      // this.imageGalleryModal = false;
    },
    selectArtWorkImage: function () {
      this.imageGalleryModal = false;
      console.log(this.artWorkId, this.artWorkUrl);
    },

    clickCallback(pageNo) {
      if (this.user_type == "Brand_Designer") {
        this.keyword = "all";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      } else if (this.user_type == "Graphics_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      }
    },

    clickCallback1(pageNo) {
      if (this.user_type == "Brand_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      } else if (this.user_type == "Graphics_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      }
    },

    clickCallback2(pageNo) {
      if (this.user_type == "Brand_Designer") {
        this.keyword = "edited";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      } else if (this.user_type == "Graphics_Designer") {
        this.keyword = "me";
        this.type = "Shape";
        this.getGraphicsDesignListing(this.keyword, this.type, this.pageNo);
      }
    },

    getGraphicsDesignListing: function (keyword, type, pageno) {
      const Obj = {
        user_type: this.user_type,
        user_id: this.user_id,
        keyword: keyword,
        type: type,
        limit: "12",
        page_no: pageno,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getGraphicsDesignListing`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "successful") {
            this.design_details = response.data.returnvalue;
            console.log(this.design_details, "this.comment_details");

            this.total_design_rows = response.data.totalCount;
            console.log("HHHHHH", this.total_design_rows);

            this.noofpages = parseInt(this.total_design_rows) / 6;

            this.noofpages = Math.ceil(this.noofpages);
            this.total_records.push(response.data.returnvalue.length);
            var temp = [];
            for (var i = 0; i <= this.total_records; i++) {
              this.count_arr.push(i);
            }
          } else if (response.data.returnmsg === "unsuccessful") {
            this.errorMsg = "No Data";
            this.design_details = [];
          }
        });
    },

    // upload large file code starts
    async handleUpload() {
      if (!this.container.file) return;

      document.getElementById("overlay").style.display = "block";
      try {
        const fileChunkList = this.createFileChunk(this.container.file);
        this.container.hash = await this.calculateHash(fileChunkList);

        const { shouldUpload, uploadedList } = await this.verifyUpload(
          this.container.file.name,
          this.container.hash
        );
        if (!shouldUpload) {
          this.$fire({
            text: "Error In File Upload",
            type: "warning",
            timer: 30000,
          });
          return;
        } else {
          this.data = fileChunkList.map(({ file }, index) => ({
            fileHash: this.container.hash,
            index,
            hash: this.container.hash + "-" + index,
            chunk: file,
            size: file.size,
            percentage: uploadedList && uploadedList.includes(index) ? 100 : 0,
          }));

          console.log("uploading chunks----------------------------->");
          await this.uploadChunks(uploadedList);
          this.modalVisible = false;
        }
      } catch (err) {
        console.log("handleUpload err------------->" + err);
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Error in file upload",
          type: "error",
          timer: 30000,
        });
      }
    },

    // xhr request
    request({
      url,
      method = "post",
      data,
      headers = {},
      onProgress = (e) => e,
      requestList,
    }) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.upload.onprogress = onProgress;
        xhr.open(method, url);
        Object.keys(headers).forEach((key) =>
          xhr.setRequestHeader(key, headers[key])
        );
        xhr.send(data);
        xhr.onload = (e) => {
          // remove xhr which status is success
          if (requestList) {
            const xhrIndex = requestList.findIndex((item) => item === xhr);
            requestList.splice(xhrIndex, 1);
          }
          resolve({
            data: e.target.response,
          });
        };
        // export xhr
        // requestList?.push(xhr);
        if (requestList) requestList.push(xhr);
      });
    },

    // create file chunk
    createFileChunk(file, size = SIZE) {
      const fileChunkList = [];
      let cur = 0;
      while (cur < file.size) {
        fileChunkList.push({ file: file.slice(cur, cur + size) });
        cur += size;
      }
      return fileChunkList;
    },

    // use web-worker to calculate hash
    calculateHash(fileChunkList) {
      return new Promise((resolve) => {
        this.container.worker = new Worker("/hash.js");
        this.container.worker.postMessage({ fileChunkList });
        this.container.worker.onmessage = (e) => {
          const { percentage, hash } = e.data;
          if (hash) {
            resolve(hash);
          }
        };
      });
    },

    // verify that the file has been uploaded based on the hash
    // skip if uploaded
    async verifyUpload(filename, fileHash) {
      const { data } = await this.request({
        url: `${CONSTANTS.API_URL}/verifyFileUpload`,
        headers: {
          "content-type": "application/json",
        },
        data: JSON.stringify({
          filename,
          fileHash,
        }),
      });
      return JSON.parse(data);
    },

    // upload chunks and filter uploaded chunks
    async uploadChunks(uploadedList = []) {
      try {
        document.getElementById("overlay").style.display = "block";
        const requestList = this.data
          .filter(({ hash }) => !uploadedList.includes(hash))
          .map(({ chunk, hash, index }) => {
            console.log("chunk------------------------------>");
            console.log(chunk);
            const formData = new FormData();
            formData.append("chunk", chunk);
            formData.append("hash", hash);
            formData.append("filename", this.container.filename);
            formData.append("fileHash", this.container.hash);
            formData.append("filetype", this.container.filetype);
            return { formData, index };
          })
          .map(({ formData, index }) =>
            this.request({
              url: `${CONSTANTS.API_URL}/uploadFileChunk`,
              data: formData,
              // onProgress: this.createProgressHandler(this.data[index]),
              requestList: this.requestList,
            })
          );
        await Promise.all(requestList);
        // merge chunks when the number of chunks uploaded before and
        // the number of chunks uploaded this time
        // are equal to the number of all chunks
        if (uploadedList.length + requestList.length === this.data.length) {
          document.getElementById("overlay").style.display = "none";
          await this.mergeRequest();
        }
      } catch (err) {
        console.log("uploadChunks err-------------------->");
        document.getElementById("overlay").style.display = "none";
      }
    },

    // notify server to merge chunks
    async mergeRequest() {
      console.log('this.container.hash',this.container.hash);
      console.log('this.container.filename',this.container.filename);
      console.log('this.container.file.type',this.container.file.type);
      document.getElementById("overlay").style.display = "block";
      let mergeResult = await this.request({
        url: `${CONSTANTS.API_URL}/mergeFileChunk`,
        headers: {
          "content-type": "application/json",
        },
        data: JSON.stringify({
          size: SIZE,
          fileHash: this.container.hash,
          filename: this.container.filename,
          filetype: this.container.file.type,
        }),
      });

      let mergeResultData = JSON.parse(mergeResult.data);
      console.log("merge result----------------------->");
      console.log(mergeResult);
      console.log(mergeResultData);
      if (mergeResultData.result == "success") {
        this.sytleImageurl = mergeResultData.image_url;
        this.stylePdfUrl = mergeResultData.pdf_url;
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Files Uploaded Successfully!",
          type: "success",
          timer: 30000,
        });
      } else {
        console.log('error!!!!!!!!!!!!!!!!!!!',error);
        this.sytleImageurl = "";
        this.stylePdfUrl = "";
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Error in uploading style image!",
          type: "error",
          timer: 30000,
        });
      }
    },
    // upload large file code ends
    cancelmodal(){
      this.editstyleModal = false ; 
    },
    getUserRestrictedSubCat(user_id,cat_id,brand_id){
      const Obj = {
        user_id: user_id,
        cat_id: `${cat_id}`,
        brand_id:`${brand_id}`
      };
      axios
        .post(`${CONSTANTS.API_URL}/userRestrictedSegment`, Obj)
        .then((response) => {
          if (response.data.returnmsg.toLowerCase()  == "successful") {
            this.sub_cat_id_arr = response.data.returnvalue;
          }else if (response.data.returnmsg === "unsuccessful") {
            this.sub_cat_id_arr = [];
                this.$fire({
                  text: response.data.returnvalue,
                  type: "error",
                  timer: 30000,
                });
          }else{
            this.sub_cat_id_arr = [];
                this.$fire({
                  text: 'Error in getting user restricted sub category',
                  type: "error",
                  timer: 30000,
                });
          }
        })
    },
      handleDragEnterSample() {
    this.isDraggingSample = true;
  },
  handleDragOverSample() {
    this.isDraggingSample = true;
  },
  handleDragLeaveSample() {
    this.isDraggingSample = false;
  },
  handleDropSample(e) {
    this.isDraggingSample = false;

    const droppedFile = e.dataTransfer.files[0];
    if (!droppedFile) return;

    // Only image allowed
    if (!droppedFile.type.startsWith("image/")) {
      this.$bvToast.toast("Please upload image only (PNG/JPG/JPEG).", {
        title: "Invalid File",
        variant: "danger",
        solid: true
      });
      return;
    }

    this.file1 = droppedFile;
    this.AddSampleimage({ target: { files: [droppedFile] } });
  },

  formatFileSize(size) {
    const kb = size / 1024;
    return kb < 1024 ? kb.toFixed(1) + " KB" : (kb / 1024).toFixed(2) + " MB";
  }
  },
};
</script>

<style>
/*.modal-content { width: 330px !important;margin:auto !important; }  */
.modal-footer {
  display: none;
}
.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
  padding-left: 1px;
  padding-right: 1px;
  padding-top: 0px;
  /*background: #F8F9F9*/
}
#cardbody {
  background: #f8f9f9 !important;
}

#btn_design {
  top: 136px;
  left: 115px;
  position: absolute;
  width: 139px;
  height: 43px;
}

#element.style {
  top: 136px;
  left: 115px;
  position: absolute;
  width: 130px;
  height: 43px;
}
#title {
  float: right;
}

@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
    height: 354px;
  }
}
@media (max-width: 414px) {
  /*  .uploadfile{
    overflow: hidden;
  }*/
  .custom-file-label {
    overflow: hidden;
  }
  .fileshead {
    font-size: 0.75em;
  }
  .filesbody {
    font-size: 0.75em;
  }
  .fileunit {
    padding: 2px;
  }
  .filesize {
    padding: 1px;
  }
}

.pointer {
  cursor: pointer;
}

#modal_overlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.modal_loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
.loading {
  position: relative;

  width: 50px;
  height: 50px;
  left: 50%;
  top: 50%;
}

/* Drag and Drop Styles */
.drag-drop-zone {
  border: 2px dashed #cbd5e0;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  cursor: pointer;
}

.drag-drop-zone:hover {
  border-color: #20a8d8;
  background-color: #e3f2fd;
}

.drag-drop-zone.drag-over {
  border-color: #20a8d8;
  background-color: #e3f2fd;
  border-style: solid;
  box-shadow: 0 0 10px rgba(32, 168, 216, 0.3);
}

.drag-drop-content {
  pointer-events: none;
}

.drag-drop-content p {
  margin: 0;
  color: #6c757d;
}

.drag-drop-content strong {
  color: #495057;
  font-size: 1.1rem;
}

.drag-drop-zone .custom-file {
  pointer-events: auto;
}
</style>
